<template>
    <div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece">
            <div class="h-pieceTitle2">
                <h1>项目信息</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine h-enter">
                    <el-form :model="ProMain" label-position="right" ref="formLabelAlign" :inline="true"
                             class="demo-ruleForm h-formbLine"
                             :rules="rules">
                        <el-form-item label="项目名称" class="h-elformWrap-2" style="position:relative" prop="gongjuproName">
                            <el-input v-model="ProMain.gongjuproName" placeholder="请输入项目名称" @change="kankanming" :readonly="shenpiyemian || zhidumoshi">
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="quyu" label="区域" :rules="[
								  { required: true, message: '请选择区域', trigger: 'change'},
								]"
                                      class="h-elformWrap-2">
                            <brselect clearable category="haiwaiquyu_cesuan" :v="ProMain.des" v-model="ProMain.des"
                                      @change="xuanquyu"
                                      :disabled="shenpiyemian || zhidumoshi" :valuecodedes="true"></brselect>
                        </el-form-item>

                       <!--  <el-form-item label="客户" class="h-elformWrap-2" style="position:relative" prop="xuanzhongren">
                            <el-input v-model="ProMain.xuanzhongren" placeholder="请选择" readonly>
                                <i v-if="shenpiyemian" class="el-icon-search el-input__icon" slot="suffix">
                                </i>
                                <i v-else class="el-icon-search el-input__icon" slot="suffix" @click="tanchuxuanzeren">
                                </i>

                            </el-input>
                        </el-form-item> -->

                        <el-form-item prop="zhangqi" label="账期" :rules="[
								  { required: true, message: '请选择账期', trigger: 'change'},
								]"
                                      class="h-elformWrap-2">
                            <brselect clearable category="zhangqi_cesuan" :v="ProMain.zhangqi" v-model="ProMain.zhangqi"
                                      :disabled="shenpiyemian || zhidumoshi"></brselect>
                        </el-form-item>

                        <el-form-item prop="repairtype" label="保修期" :rules="[
								  { required: true, message: '请选择保修期', trigger: 'change'},
								]"
                                      class="h-elformWrap-2" ><!--v-if="kaishixuanzeshiyongren||shenpiyemian"@change="repairchangetype"-->
                            <brselect clearable category="baoxiuqi_cesuan" :v="ProMain.repairtype"
                                      v-model="ProMain.repairtype" 
                                      :disabled="shenpiyemian || zhidumoshi"></brselect>
                        </el-form-item>

                        <!-- <el-form-item class="h-elformWrap-1 ljjrange" label="特价有效期" prop="youxiaoqi"
                                      >
                            <el-col>
                                <el-date-picker v-model="ProMain.youxiaoqi" type="daterange" range-separator=" 至 "
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期" style="width: 6rem" value-format="yyyy-MM-dd"
                                                :readonly="shenpiyemian">
                                </el-date-picker>

                            </el-col>
                        </el-form-item>  -->
                              <el-form-item
                                class="h-elformWrap-1 ljjrange"
                                label="选择特价有效期"
                                prop="youxiaoqi"
                                :rules="[{ required: true, message: '请选择特价有效期', trigger: 'change'},]">
                                <!-- <el-date-picker
                                        v-model="ProMain.youxiaoqi"
                                        type="daterange"
                                        range-separator=" 至 "
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        style="width: 6rem"
                                        value-format="yyyy-MM-dd"
                                >
                                </el-date-picker> -->
                                <el-date-picker
                                    style="width: 2rem;"
                                    v-model="ProMain.youxiaoqistart"
                                    clearable
                                    type="date"
                                    placeholder="请选择开始时间"
                                    value-format="yyyy-MM-dd"  :readonly="shenpiyemian || zhidumoshi">
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                    style="width: 2rem;"
                                    v-model="ProMain.youxiaoqi"
                                    clearable
                                    placeholder="请选择结束时间"
                                    type="date"
                                    value-format="yyyy-MM-dd" :readonly="shenpiyemian || zhidumoshi">
                                </el-date-picker>
                        </el-form-item>
                        <el-form-item label="立项说明" class="h-elformWrap-2" v-if="xinzeng || (beibohui && !yiban && !zhidumoshi)">
                            <brupload
                                    @filecallback="kankantijiao"
                                    :refid=ProMain.lixiangid
                                    :reftype=ylcsfujian
                                    uploadflag 
                                    delflag
                                    :limit="1"
                                    :showtime="false"
                            >

                               <el-button size="small" type="text">上传</el-button>
                            </brupload>
                        </el-form-item>
                      <el-form-item label="立项说明" class="h-elformWrap-2" v-if="zhidumoshi || (shenpiyemian && !beibohui && !yiban)">
                            <brupload
                                    @filecallback="kankantijiao"
                                    :refid=ProMain.lixiangid
                                    :reftype=ylcsfujian
                                   
                                    :limit="1"
                                    :showtime="false"
                                
                                   
                            >

                               <el-button size="small" type="text">上传</el-button>
                            </brupload>
                        </el-form-item>
                        <el-form-item label="立项说明" class="h-elformWrap-2" v-if="this.yiban">
                            <brupload
                                    @filecallback="kankantijiao"
                                    :refid=ProMain.lixiangid
                                    :reftype=ylcsfujian
                                   
                                    :limit="1"
                                    :showtime="false"
                                
                                   
                            >

                               <el-button size="small" type="text">上传</el-button>
                            </brupload>
                        </el-form-item>

                        <!-- <el-form :model="form" ref="form" class="demo-form-inline" label-position="right" >


                            <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
                                    { required: true, message: '必须输入选项', trigger: 'blur'}]" v-if="!shenpiyemian&&!beibohui">
                                <el-select v-model="form.dalei" filterable @change="handleItemChange1" placeholder="大类">
                                    <el-option
                                            v-for="item in list1"
                                            :key="item.value"
                                            :label="item.prodseries"
                                            :value="item.oneLid">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="物料" class="h-elformWrap-2"  v-if="!shenpiyemian&&!beibohui" >
                                <el-select v-model="form.wuliao"
                                           filterable
                                           placeholder="物料">
                                    <el-option
                                            v-for="item in list2"
                                            :key="item.value"
                                            :label="item.promodel"
                                            :value="item.prodcode">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-button type="primary" @click="huidiao" style="margin-top:-10px" v-if="!shenpiyemian&&!beibohui">清空</el-button>
                            <el-button type="primary" @click="danxinghao" style="margin-top:-10px">单型号测算</el-button>
                            <el-button type="primary" @click="zhuijiaxinghao" style="margin-top:-10px" v-if="!shenpiyemian&&!beibohui">选择型号</el-button>


                            <el-form-item label="物料号" class="h-elformWrap-2" v-if="duoxinghao" >

                                <el-input v-model="duoxinghaocesuan.toString()" placeholder="" disabled="disabled"></el-input>


                            </el-form-item>
							<el-form-item label="" class="h-elformWrap-2" v-if="duoxinghao" >


                                <el-button type="primary" @click="duoxinghaotijiao" style="margin-top: -0.5rem;" v-if="!xianshijilu">点击填写测算信息</el-button>

                            </el-form-item>

                        </el-form> !shenpiyemian-->


                        <div class="l-style">
                            <div class="cesuantitles">测算型号：</div>
                            <div class="l-styleBox">
                                <div class="l-stylelist" v-for="(item,index) in duoxinghaocesuan" :key="index">
                                    <div class="l-styletext">
                                        {{item}}
                                        <div v-if="!zhidumoshi && !shenpiyemian && !bianjiOrbohui" class="l-styledel"
                                             @click="delwuliao(item)">x
                                        </div>
                                    </div>
                                </div>
                                <el-button class="h-btn h-bgblueQ2"
                                           style="border-radius: 0.2rem;font-size: 0.2rem;margin-left: 0.1rem;padding: 0.05rem 0.1rem;"
                                           type="primary"
                                           @click="adds" v-if="!zhidumoshi &&!shenpiyemian && !bianjiOrbohui">+
                                </el-button>
                            </div>
                        </div>
                        <div v-if="!zhidumoshi && !shenpiyemian">
                            <div v-if="shengchengflag"
                                 style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
                                <div style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
                                     @click="danxinghao">生成
                                </div>
                                <div style="margin-left:0.2rem;padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #fff;color: #323232;border: 1px solid #959595;font-size: 0.16rem;text-align: center;cursor: pointer;"
                                     @click="qingkonganniu">清空
                                </div>
                            </div>
                            <div v-else
                                 style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
                                <div style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
                                     @click="duoxinghaotijiao">生成
                                </div>
                                <div style="margin-left:0.2rem;padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #fff;color: #323232;border: 1px solid #959595;font-size: 0.16rem;text-align: center;cursor: pointer;"
                                     @click="qingkonganniu">清空
                                </div>
                            </div>
                        </div>
                        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2">
                            <div class="h-dialogImg">
                                <div class="h-disTable">
                                    <div class="h-tableCell">
                                        <h1>新增测算型号</h1>
                                        <p>New Calculation Model</p>
                                    </div>
                                </div>
                            </div>
                            <div class="h-formLines tan">
                                <div>
                                    <el-form :model="form" label-position=right ref="form" :inline="true"
                                             class="demo-ruleForm h-formbLine">
                                      

                                        <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
										        { required: true, message: '必须输入选项', trigger: 'blur'}]"
                                                      v-if="!shenpiyemian">
                                            <el-select v-model="form.dalei" filterable @change="handleItemChange1"
                                                       placeholder="大类">
                                                <el-option v-for="item in list1" :key="item.value"
                                                           :label="item.levelname" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="物料" class="h-elformWrap-2" @change="changewuliao"
                                                      v-if="!shenpiyemian">
                                            <el-select v-model="form.wuliao" filterable placeholder="物料">
                                                <el-option v-for="item in list2" :key="item.value"
                                                           :label="`[${item.materialCode}] ${item.materialDescrition}`"
                                                           :value="item.materialCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <div style="display:flex;justify-content:center;padding-bottom:20px">
                                    <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取消</el-button>
                                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="queren">确认</el-button>
                                </div>
                            </div>
                        </el-dialog>

                        <el-form-item label="" class="h-elformWrap-2"></el-form-item>

                        <!-- <showxuanzerencesuan :visible.sync="xuanzeren" ddlx="2" v-if="xuanzeren"
                                             @choseObj="shiyongrenxuanze" oneflag
                                             title="选择经销商"/>
 -->

                        <br>

                        <el-form-item v-if="shenpiyijianshow" label="原始版本查看" class="h-elformWrap-2 " prop="xiangmucode">

                            <el-button type="text" size="small" class="h-tableLink h-btn" @click="cesuanbanbenchakan">
                                原始版本查看
                            </el-button>

                        </el-form-item>

                        <br>

                        <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="shenpiyijianshow">
                            <el-input v-model="ProMain.shenpiyijian" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>

                    </el-form>

                    <!--<div class="xia" v-if="!this.shenpiyemian&&!beibohui" style="margin-top: 0.1rem;">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanben">选择计算版本</el-button>
                    </div>-->

                    <div class="anniu" v-if="guanliyuan" style="margin-top: 0.3rem;">
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="gongshiduizhaokai">公式对照表
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xianshijisuanguocheng">显示计算过程
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xiangxixinxixianshi">显示详细计算信息
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="kankanyichang">
                            异常信息
                        </el-button>
                    </div>

                </div>
            </div>
        </div>
        <div class="h-table ljjtableenterlkw">
            <el-table :data="tableData" :span-method="objectSpanMethod" @cell-dblclick="dblclick" :row-style="cellstyle"
                      border
                      max-height="500"
                      style="width: 100%; margin-top: 20px" :row-class-name="tableRowClassName">
                <el-table-column prop="message" label="分类" width="140" fixed :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="coding" label="科目" :show-overflow-tooltip="true" width="190" fixed>
                </el-table-column>
                <el-table-column prop="shuoming" label="说明" :show-overflow-tooltip="true" min-width="200">
                    <template slot-scope="scope">

                        <!--                        <div v-if="scope.$index ==4" @click="tianjiadingjia">-->
                        <!--                            <div style="font-size: 20%;color: red" >点击手动添加定价</div>-->
                        <!--                        </div>-->

                        <div v-if="scope.$index ==28" @click="showlvaction">
                            <div>{{scope.row.shuoming}}</div>
                            <div style="font-size: 20%;color: red">点击手动添加售后换机率</div>
                        </div>

                        <div v-else>{{scope.row.shuoming}}</div>

                    </template>


                </el-table-column>

                <el-table-column prop="hejiL" width="140" label="合计-率" :show-overflow-tooltip="true">

                    <template slot-scope="scope">
                        <div v-if="scope.$index == 5
						||scope.$index == 15
						||scope.$index == 16
						||scope.$index == 17
						||scope.$index == 19
						||scope.$index == 20
						||scope.$index == 21
						||scope.$index == 22
						||scope.$index == 23
						||scope.$index == 24
						||scope.$index == 25
						|| scope.$index == 26
						|| scope.$index == 27
						|| scope.$index == 28
						|| scope.$index == 29
						|| scope.$index == 30
						|| scope.$index == 31
						|| scope.$index == 32
						|| scope.$index == 33
						|| scope.$index == 34
						|| scope.$index == 35
						|| scope.$index == 36
						|| scope.$index == 37
						|| scope.$index == 38
						|| scope.$index == 39
						|| scope.$index == 40
						|| scope.$index == 41
						|| scope.$index == 42
						|| scope.$index == 43
						|| scope.$index == 44
						|| scope.$index == 45
						|| scope.$index == 46
						||scope.$index > 46"
                             :title="scope.row.hejiL">{{new big(Number(scope.row.hejiL).toFixed(2)).times('100') + '%'}}
                        </div>
                        <div v-else>{{scope.row.hejiL}}</div>
                    </template>

                </el-table-column>
                <el-table-column prop="hejiE" width="140" label="合计-额" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.$index==5||scope.$index==21||scope.$index==40||scope.$index==46||scope.$index>46"
                             :title="scope.row.hejiE">{{new big(Number(scope.row.hejiE).toFixed(2)).times('100') + '%'}}
                        </div>
                        <div v-else-if="scope.$index==13" :title="scope.row.hejiE">
                            {{Number(scope.row.hejiE).toFixed(4)}}
                        </div>
                        <div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">
                            {{scope.row.hejiE}}
                        </div>
                        <div v-else :title="scope.row.hejiE">{{Number(scope.row.hejiE).toFixed(2)}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" :prop="item.prop" :label="item.label" v-for="item in columndata"
                                 :key='item.label'>

                    <template slot-scope="scope">

                        <div v-if="shenpiyemian">

                          
                            <div v-if="scope.$index == 0 || scope.$index == 1 || scope.$index == 2 || scope.$index == 3">
                                {{scope.row[item.prop]}}
                            </div>
                            <div v-else-if=" scope.$index == 14
							|| scope.$index == 15
							|| scope.$index == 16
							|| scope.$index == 17
							|| scope.$index == 19
							|| scope.$index == 20
							|| scope.$index == 21
							|| scope.$index == 38
							|| scope.$index == 39
							|| scope.$index == 40
							|| scope.$index == 44
							|| scope.$index == 45
							|| scope.$index == 46
">{{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}
                            </div>
                            <el-input class="h-tableInput" v-else-if="scope.row['flags' + item.flagsindex]==true"
                                      v-model="scope.row[item.prop]" v-focus
                                      @blur="caiwugaishula(scope.row,scope.row[item.prop],item.flagsindex)"></el-input>
                            <div style="border:1px solid #DCDFE6;padding: 0.05rem 0;text-align: left;padding-left: 0.1rem;"
                                 v-else :title="scope.row[item.prop]"
                                 @click="clickjiage(scope.row,item.flagsindex)">
                                {{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}
                            </div>
                        </div>

                        <div v-else>

                            <el-input class="123 h-tableInput"
                                      v-if="scope.$index == 4
                                      || scope.$index == 6
                                      || scope.$index == 7
                                      || scope.$index == 8
                                      || scope.$index == 9
                                      || scope.$index == 10
                                      || (scope.$index ==18 && (scope.row['sunyixianshi' + item.dijige]==true))
                                      || (scope.$index ==22 && (scope.row['sunyixianshi' + item.dijige]==true))
                                      || scope.$index == 31"
                                       @blur="checkNums(scope.row[item.prop],scope.$index,item.prop)"
                                      v-model="scope.row[item.prop]"></el-input>


                            <!-- <div class="456" v-else>{{scope.row[item.prop]}}</div> -->
                            <div v-else>
                                <div v-if="scope.$index==5||scope.$index==21||scope.$index==40||scope.$index==46"
                                     :title="scope.row[item.prop]">{{new
                                    big(Number(scope.row[item.prop]).toFixed(2)).times('100') + '%'}}
                                </div>
                                <div v-else-if="scope.$index==13" :title="scope.row[item.prop]">
                                    {{Number(scope.row[item.prop]).toFixed(4)}}
                                </div>
                                <div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">
                                    {{scope.row[item.prop]}}
                                </div>
                                <div v-else :title="scope.row[item.prop]">{{Number(scope.row[item.prop]).toFixed(2)}}
                                </div>
                            </div>

                        </div>

                    </template>

                </el-table-column>


            </el-table>

            <!-- <div class="h-tableB h-mrt30" style="height: 1rem;" v-if="!this.shenpiyemian">

              
            </div> -->

        </div>


        <div style="margin:20px" v-if="xianshinage==0 && (this.caiwuShpFlag || this.guanliyuan || this.caiwu)">
            <div class="yx_progressBar">
                <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                    <div style="margin-bottom: 0.2rem;" v-if="!this.shenpiyemian">该申请价格达到盈利目标</div>
                </div>
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData[40].hejiE*100|rounding}}%</span>
                    </div>


                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData[46].hejiE*100|rounding}}%</span>
                    </div>


                </div>

            </div>
        </div>


        <div style="margin:20px" v-else-if="xianshinage==1 && (this.caiwuShpFlag || this.guanliyuan || this.caiwu)">
            <div class="yx_progressBar yx_progressBarAc">
                <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                    <div style="margin-bottom: 0.2rem;" v-if="!this.shenpiyemian"></div>

                </div>
                <!--            <el-button class="h-btn h-bgblueQ2" @click="tijiaoshenqingtejia" style="position:absolute;top:0.3rem;right: 0.7rem" v-if="!this.shenpiyemian">发起特价申请</el-button>-->
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData[40].hejiE*100|rounding}}%</span>
                    </div>


                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData[46].hejiE*100|rounding}}%</span>
                    </div>


                </div>

            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


        <div v-if="!zhidumoshi">


            <div v-if="shenpiyemian">

                <div class="h-table h-mrt30 h-rowBox ffff" style="margin:0.2rem" v-if="this.caiwu || this.guanliyuan">
                    <div class="h-pieceTitle2 hang" style="background: #fff;padding-top: 0.2rem;">
                        <h1 class="h1" style="margin-left:0.2rem">审批意见</h1>
                        <el-form :model="yinglishenpi" label-position="right" ref="yinglishenpi" :inline="true"
                                 :rules="shenpirules"
                                 class="demo-ruleForm h-formbLine">
                            <div class="h-txtLeft">
                                <el-form-item label="审批意见" class="h-elformWrapz-1" prop="shenheyijian"
                                              style="margin-top:0.2rem;margin-left: 0.2rem;">
                                    <el-input v-model="yinglishenpi.shenheyijian" placeholder="审批意见"
                                              style="width:4rem"></el-input>
                                </el-form-item>
                                <br>
                            </div>
                        </el-form>
                    </div>
                </div>


                <div class="xia">
					<el-button v-if="!this.caiwu && !this.guanliyuan" size="small" class="h-btn h-bBtn h-bgwhite"
					           @click="fanhui">
					   返回
					</el-button>
                   <el-button size="small" class="h-btn h-bBtn h-bgwhite"
                               @click="caiwuzancunyuanshibanben">
                        原始审批版本查看
                    </el-button>
                    <el-button size="small" class="h-btn h-bBtn h-bgwhite"
                               @click="qiehuanbanbencaiwuzancun">
                        查看暂存
                    </el-button>
                    
                    <el-button v-if="!caiwugaishutongguo"  size="small" class="h-btn h-bBtn h-bgblueQ2"
                               @click="showhistory = true">
                        跟踪审批
                    </el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" v-if="this.caiwu || this.guanliyuan" @click="shenpijisuan">
                        计算
                    </el-button>
                    <el-button class="h-btn h-bBtn h-bgblue2" v-if="(this.caiwu || this.guanliyuan) && !this.yiban"
                               @click="xiugaitijiao">
                        修改提交通过
                    </el-button>

                    <el-button class="h-btn h-bBtn h-bggreen" v-if="(this.caiwu || this.guanliyuan) && !this.yiban"

                               @click="caiwuzancun">
                        暂存
                    </el-button>

                    <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu" v-if="this.caiwu || this.guanliyuan">返回</el-button>
                    <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                               @click="bohuianniu('yinglishenpi')" v-if="!dangqiancaiwuzancun && (this.caiwu || this.guanliyuan) && !this.yiban">驳回
                    </el-button>
                    <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default"
                               @click="tongguoanniu" v-if="!dangqiancaiwuzancun && (this.caiwu || this.guanliyuan) && !this.yiban">原版通过
                    </el-button>
                </div>

            </div>


            <div class="xia" v-else>
               <!-- <el-button class="h-btn h-bBtn h-bgwhite" @click="handleDelete" v-if="!shifouzhidu">删除版本</el-button>-->
                <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="haiwaicesuan(0)"
                           v-if="!beibohui&&!shifouzhidu">暂存
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="haiwaicesuan(9)"
                           v-if="beibohui || !shifouzhidu">计算
                </el-button>
                <el-button class="h-btn h-bBtn bgblueQ2"  @click="haiwaicesuan(1)"
                           v-if="!beibohui&&!shifouzhidu">
                    确认提交
                </el-button>
                <el-button class="h-btn h-bBtn bgblueQ2" @click="chongxintijiao"
                           v-if="beibohui && !this.caiwu">
                    重新提交
                </el-button>

            </div>

        </div>
        <div v-else style="display: flex;justify-content: center;">
              <el-button class="h-btn h-bBtn bgblueQ2" @click="fanhuiliebiao">返回</el-button>
        </div>


        <!-- 选择测算版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="refuseDialog" class="h-dialog2" @close="gettable">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择以往测算版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="refuseDialog=false">确定</el-button>
                    </div>

                </div>

            </div>


        </el-dialog>

        <!-- 选择财务暂存版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="showcaiwuzancun" class="h-dialog2" @close="gettablecaiwuzancun">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择财务暂存版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="showcaiwuzancun=false">确定</el-button>
                    </div>

                </div>

            </div>


        </el-dialog>


        <!-- 添加售后换机率 -->
        <el-dialog :visible.sync="showlv" class="h-dialog2" :show-close="true" :close-on-click-modal="false">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>添加售后换机率</h1>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="huanjilv" placeholder="请选择" style="width:7rem;" @change="huanjilvxuanze">
                        <el-option v-for="item in showlvop" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>

                    <el-input v-model="shuruhuanjilv" v-if="keyishuru" placeholder="请输入.xxx"
                              @blur="dongtaishezhi"></el-input>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="shezhihuanjilv">确定</el-button>
                    </div>

                </div>

            </div>

        </el-dialog>


        <!-- 选择定价 -->
        <el-dialog :visible.sync="showdingjia" class="h-dialog2" :show-close="true" :close-on-click-modal="false">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择定价</h1>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="dingjiaone" placeholder="请选择" style="width:7rem;" @change="dingjiaxuanze">
                        <el-option v-for="item in showdingjiaop" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>


                    <el-select v-model="shurudingjia" placeholder="请选择" style="width:7rem;"
                               @change="dongtaishezhidingjia" v-if="keyixuanze">
                        <el-option v-for="item in showdingjiaoplist" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>


                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="shezhidingjia">确定</el-button>
                    </div>

                </div>

            </div>

        </el-dialog>


        <!-- 计算过程 -->
        <el-dialog :visible.sync="jisuanjiluxianshi" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="jisuanjilujieguostr" readonly rows="50"></el-input>


                <!--                <el-table-->
                <!--                        :data="jisuanjilujieguo"-->
                <!--                        @cell-dblclick="dblclick"-->
                <!--                        border-->
                <!--                        style="font-size: x-small;white-space: pre-wrap;"-->
                <!--                >-->

                <!--                    <el-table-column-->
                <!--                            prop="xuhao"-->
                <!--                            width="200"-->
                <!--                            label="项"-->

                <!--                    >-->
                <!--                    </el-table-column>-->

                <!--                    <el-table-column-->
                <!--                            prop="xinxi"-->
                <!--                            width="1000"-->
                <!--                            label="信息"-->

                <!--                    >-->
                <!--                    </el-table-column>-->


                <!--                </el-table>-->

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jisuanjiluxianshi=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 计算详细记录 -->
        <el-dialog :visible.sync="xiangxijilu" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="xiangxijilujieguo" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="xiangxijilu=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 公式对照表 -->
        <el-dialog :visible.sync="gongshiduizhao" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="gongshiduizhaobiao" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="gongshiduizhao=false">确定</el-button>
            </div>


        </el-dialog>

        <!-- 异常信息 -->
        <el-dialog :visible.sync="jianchayichang" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="yichangxinxi" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jianchayichang=false">确定</el-button>
            </div>


        </el-dialog>


    </div>


</template>


<script>
    import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        components: {
            showxuanzerencesuan
        },

        data() {

            return {
                ylcsfujian: "盈利测算立项说明",

                yishengcheng: false,

                zancunid: '',

                dangqiancaiwuzancun: false,

                showcaiwuzancun: false,

                zonggeshu: 0,

                baocunbianliangb: '',

                caiwu: false,

                //只读版本id
                cesuanid: '',

                //财务改数直接通过的没有审批流
                caiwugaishutongguo: false,

                zhidumoshi: false,
                bianjiOrbohui:false,

                jisuancishu: 0,

                baocuntable: [],

                zhiqianbanben: {},

                meiyoubanben: false,

                beigaishude: [],

                shengchengflag: true,
                wuliaotext: '',

                f: {
                    dalei: '',
                    wuliao: ''
                },

                frules: {
                    dalei: [{
                        required: true,
                        message: '请选择大类',
                        trigger: 'blur'
                    }],
                    wuliao: [{
                        required: true,
                        message: '请选择物料',
                        trigger: 'blur'
                    }]
                },
                quanxianflag:false,

                dialogFormVisible1: false,

                yichangxinxi: '',

                jianchayichang: false,

                gongshiduizhaobiao: '',

                gongshiduizhao: false,

                xiangxijilu: false,

                xiangxijilujieguo: '',

                jisuanjilujieguostr: '',

                cesuanbiaoshi: [],

                jisuanjilujieguo: [],

                jisuanjiluxianshi: false,

                //管理员
                guanliyuan: false,

                kaishixuanzeshiyongren: false,


                xuanzeren: false,


                //销售经理判断
                shifouxiaoshoujingli: false,

                xianshijilu: false,

                //定价集
                dingjialist: {},

                //区域编码xx_xx  损益查
                quyubianma: '',

                //区域编码xxxx  定价查
                quyubianma2: '',

                queryq: {
                    pcode: 0,
                    oneLid: '',

                },

                duoxinghaocesuan: [],

                duoxinghao: false,

                form: {

                    dalei: '',
                    wuliao: '',

                },

                list1: [],

                list2: [],


                wuliaolist: [],

                //被驳回
                beibohui: false,


                yinglishenpi: {

                    shenheyijian: '',

                },

                shenpirules: {
                    shenheyijian: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                },


                //审批页面
                shenpiyemian: false,
                //  新增时
                xinzeng:true,
                yiban:false,

                chushihuabiao: false,

                keyishuru: false,

                keyixuanze: false,


                huanjilv: '',

                dingjiaone: '',

                shuruhuanjilv: '',

                shurudingjia: '',


                showdingjia: false,

                showlv: false,


                showlvop: [],

                showdingjiaop: [],

                showdingjiaoplist: [],


                //海外项目产品id数组
                haiwaixiangmuchanpin: [],


                //驳回版本id
                delrversion: null,

                shenpiyijianshow: false,

                showhistory: false,

                instid: null,


                //前页项目
                qianyexiangmu: {},

                //选择项目参数
                rateFormulaRenewXiangmucanshu: null,

                //计算返回版本id
                fanhuibanbenid: null,

                //计算版本
                rversion: null,


                guochenglist: [],

                caiwuzancunlist: [],

                xuanzhongbanben: [],

                refuseDialog: false,


                banbenid: '',


                banbenop: [],


                //计算过程对象
                rateFormulaRenewVer: {},


                //显示哪个利率总计框
                xianshinage: 9,

                jingyinggongxiangzong: 0,

                lirunzong: 0,

                zongmaolilvbiao: 0,

                zongmaolilv: 0,


                // 进度
                progressBar: [{
                    name: "王振刚",
                    ifBlue: 1,
                    ifing: 0
                },
                    {
                        name: "总部管理员",
                        ifBlue: 1,
                        ifing: 0
                    },
                    {
                        name: "财务经理",
                        ifBlue: 2,
                        ifing: 0
                    },
                    {
                        name: "待审核",
                        ifBlue: 0,
                        ifing: 0
                    },
                ],

                list: [{
                    title: '提交人:王振刚',
                    isactive: 0,
                    time: '2019/09/10 18:00:00',
                },
                    {
                        title: '总部管理员',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '待审核',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '财务经理',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    }
                ],


                //物料号
                marcode: '',


                rules: {

                    quyu: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                    zhangqi: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                    fukuanfangshi: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                    bid: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                    repairtype: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],

                    // xuanzhongren: [
                    //     { required: true, message: '不能为空', trigger: 'blur' },
                    //
                    // ],
                    youxiaoqi: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],


                },


                ajaxRequest: {

                    pageSize: 5,
                    pageNo: 1,
                    total: 0,
                    fileName: null,

                },


                //项目产品list
                xiangmuchanpinlist: [],


                q: {

                    pageSize: 5,
                    pageNo: 1,
                    total: 0,

                },

                //全合计金额map
                allratemap: {},


                //是否首次交互
                shoucijiaohu: true,

                //申请单价含税 组
                shenqingdanjiaop: [],

                //附加成本 组
                fujiachengbenop: [],


                //附加成本
                fujiachengben: "",

                //申请单价含税
                shenqingdanjia: '',

                //项目编号
                proid: '',

                //质保选中值
                repairtype: null,


                //
                columndata: [],

                //列表翻页参数
                value3: 0,

                //上部列表信息
                ProMain: {
                    gongjuproName:'',
                    //lixiangid
                    lixiangid: this.getUUid(),
                    //选中人
                    xuanzhongren: '',
                    //使用人
                    shiyongren: '',

                      //有效期开始时间
                    youxiaoqistart:'',
                    youxiaoqi: '',

                    repairtype: '',

                    quyu: '',

                    des: '',

                    fukuanfangshi: '',

                    zhangqi: '',

                    //项目名称
                    projectName: '',

                    //投标方式
                    bidway: '',

                    //开标日期
                    bid: null,

                    //预付百分比
                    pdpay: '',

                    //首款百分比
                    fdpay: '',

                    //中款百分比
                    mdpay: '',

                    //尾款百分比
                    ldpay: '',

                    //首款天
                    fdpayday: '',

                    //中款天
                    mdpayday: '',

                    //尾款天
                    ldpayday: '',

                    //项目描述
                    projectDescription: '',

                    //终端成交价
                    zhongduanchengjiaojia: '',

                    //专营商毛利率
                    zhuanyingshangmaolilv: '',

                    //审批意见
                    shenpiyijian: '',

                },


                //当前表信息
                tableData: [],


                //所有查到的计算回调信息
                alllastlist: [],

                shifouzhidu: false,

                caiwuShpFlag: false,
            };
        },

        //加载页面默认执行
        created() {
            //查找版本
            this.chazhaocesuan();
            this.jiazaigongshibiao();
            //测算标识
            this.cesuanbiaoshi = this.$store.getters.dictlist("cesuanguocheng_cesuan");
            //销售经理
            this.shifouxiaoshoujingli = this.$store.getters.hasRole('swyl_xiaoshoujl,swyl_xiaoshoujl_wx,xiaoshoujingli-waixiao,zidonghualengku');
            //管理员
            this.guanliyuan = this.$store.getters.hasRole('swyl_admin');
            //财务
            this.caiwu = this.$store.getters.hasRole('swyl_haiwai_caiwu');

            // //判断目前使用人如果是销售经理，就会默认隐藏表格一部分
            // for(var d in this._user.roles){
            //
            //     if(this._user.roles[d].id=='swyl_xiaoshoujl'||this._user.roles[d].id=='swyl_xiaoshoujl_wx'||this._user.roles[d].id=='xiaoshoujingli-waixiao'){
            //
            //         this.shifouxiaoshoujingli = true;
            //
            //     }
            //
            //
            //     this.shifouxiaoshoujingli = this.store.hasRole('swyl_xiaoshoujl,swyl_xiaoshoujl_wx,xiaoshoujingli-waixiao');
            //
            // }
            //加载物料选择
            this.loadArea(1);

            //前页转发判断
            this.zhuanfapanduan();
            

        },

        beforeRouteLeave(to,from,next){
            if(to.path=='/rvlistshow' && from.path == '/enterseven'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        activated(){
            this.dbhandleFilter();
        },
        mounted() {


        },

        filters: {
            rounding(value) {
                return value ? value.toFixed(2) : 0;
            }
        },


        watch: {
            showlv(val) {
                if (val == false) {
                    this.huanjilv = '';
                    this.showlvop = [];
                    this.shuruhuanjilv = '';
                    this.keyishuru = false;
                }
            },

            showdingjia(val) {
                if (val == false) {
                    this.dingjiaone = '';
                    this.showdingjiaop = [];
                    this.shurudingjia = '';
                    this.keyixuanze = false;
                }
            }
        },

        directives: {
            // 注册一个局部的自定义指令 v-focus
            focus: {
                // 指令的定义
                inserted: function (el) {
                    // 聚焦元素
                    el.querySelector('input').focus()
                }
            }
        },
        methods: {
            // 验证型号输入框是否是数字或者小数
            checkNums(v,index,num){
                console.log(v,index,num,"////////");
                console.log(this.tableData[index][num],"/.............")
                if(/^(\d*)(\d*.\d+)$/.test(v) == false){
                    console.log("false.........")
                    if(/^\d$/.test(v) == false){
                        this.tableData[index][num] = '0';
                        console.log("false")
                    }else{
                        console.log("true")
                    }
                }
            },
            //看看名
            kankanming(q){

                console.log(q,'mingqqq?')

                console.log(this.ProMain.gongjuproName,'this.ProMain.gongjuproName?')

            },

            //看看提交
            kankantijiao(q){
                console.log(q,"附件");
              //  this.ProMain.lixiangid = q.length;
               
                

            },

            getUUid() {
                return this.$util.getUuid();
            },
            fanhui(){
                this.$router.push({path: '/rvlistshow'});
            },            //测算版本查看
            cesuanbanbenchakan() {

                //测算版本有的话
                if (this.cesuanid != null && this.cesuanid != '') {

                    var rversion = {

                        rversion: this.cesuanid
                    }

                    //查找测算版本
                    ss.FormulaNew.getbanben(rversion).then(rd => {

                        console.log(rd.obj, '测算')

                        //测算
                        this.neiwaixiaopanduan(rd.obj);

                    })

                }

            },

            //测算跳转判断
            neiwaixiaopanduan(q) {
                console.log(q, "asdasd????")

                var path = '';

                if (q.neixiaowaixiao == 1 && q.ispro == 1) { //外销项目
                    //跳转外销项目
                    path = '/xiangmu/entersix';

                } else if (q.neixiaowaixiao == 1 && q.ispro == 0) { //外销工具
                    //跳转外销工具
                    path = '/xiangmu/enterseven';

                } else if (q.neixiaowaixiao == 0) { //内销
                    //跳转内销测算
                    path = '/xiangmu/enterfive';

                } else if (q.neixiaowaixiao == 2) { //租赁
                    //跳转内销测算
                    path = '/rateFormulaZulinshiti';

                }

                var shiti = {
                    chakanshiti: q.rversion
                }

                console.log(shiti, 'shitishitishiti')


                let routeData = this.$router.resolve({
                    path: path,
                    query: shiti
                });
                window.open(routeData.href, '_blank');


            },


            // //判断是否只读
            // panduanshifouzhidu(q) {
            //
            //     for (var d in q.obj) {
            //
            //         //如果有不是暂存状态的历史版本，说明是只读页面
            //         if (q.obj[d].status != null && q.obj[d].status != '' && q.obj[d].status != 0) {
            //
            //             this.shifouzhidu = true;
            //
            //         }
            //
            //     }
            //
            //     console.log(this.shifouzhidu, 'this.shifouzhidu')
            //
            // },

            clickjiage(item, index) {
                console.log(item, "//./././././.")
                item['flags' + index] = true
            },

            //审批计算
            shenpijisuan() {

                this.jisuancishu++;

                console.log(this.jisuancishu, 'this.jisuancishu')

                this.haiwaicesuan(9);

            },

            chazhaocesuan() {
                var pid = {
                    neixiaowaixiao: 1,

                }
                ss.FormulaNew.findguocheng(pid).then(rd => {
                    console.log(rd, 'a')
                    if (JSON.stringify(rd.obj) == '{}') {
                        this.meiyoubanben = true;
                    } else {
                        // //判断只读
                        // this.panduanshifouzhidu(rd);
                        this.meiyoubanben = false;

                        this.zhiqianbanben = rd.obj;

                    }


                })


            },

            //判断instid
            panduaninstid(re) {

                //存在审批instid
                if (re.instid != null) {

                    this.instid = re.instid
                    //判断财务是否审批通过
                    ss.FormulaNew.searchCaiwuShpStatus(data).then(rd => {
                        if(rd.msg){
                            this.caiwuShpFlag = true;
                        }
                    })
                    //不存在
                } else {

                    //如果已经通过，说明是财务修改直接通过的
                    if (re.status == 2 && re.xid != null) {

                        this.caiwugaishutongguo = true;
                        this.caiwuShpFlag = true;
                    }

                }

            },


            //财务改数提交
            xiugaitijiao() {

                this.tijiaoagain(13);

            },


            caiwugaishula(row, zhi, index) {
                row['flags' + index] = false;
                console.log(row, zhi)

                for (var c = 1; c < 16; c++) {

                    if (row.canshuxulie != null && row.canshuxulie != '' && row['xinghao' + c] != null && row['xinghao' + c] != '' &&
                        row['xinghao' + c] == zhi) {

                        console.log(this.baocuntable, 'baocuntable');

                        for (var d in this.baocuntable) {

                            if (this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] != zhi) {

                                row['shifougaishu' + c] = true;

                                this.beigaishude.push({

                                    c: c,
                                    xinghaoji: "shifougaishu" + c,
                                    flag: true,
                                    canshuxulie: row.canshuxulie,

                                })

                            } else if (this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] == zhi) {

                                row['shifougaishu' + c] = false;

                                for (var f in this.beigaishude) {

                                    if (this.beigaishude[f].canshuxulie == row.canshuxulie && this.beigaishude[f].c == c) {

                                        this.beigaishude[f].flag = false;

                                    }

                                }

                            }

                        }


                    }

                }

                console.log(this.beigaishude, 'this.beigaishude')

            },

            // 取消物料弹窗
            cancel() {
                this.f = {}
                this.dialogFormVisible1 = false;
            },
            // 删除物料号
            delwuliao(c) {
                var ins = this.duoxinghaocesuan.indexOf(c);
                this.duoxinghaocesuan.splice(ins, 1);
                console.log(this.duoxinghaocesuan,"信号物料啥的来看看");
            },
            // 某一条物料编码
            changewuliao(v) {
                this.wuliaotext = v;
            },
            // 添加按钮
            adds() {
                this.dialogFormVisible1 = true;
            },
            // 确认物料
            queren() {
                if (this.form.dalei && this.form.wuliao) {
                    this.zhuijiaxinghao(false)
                    this.dialogFormVisible1 = false;
                    if (this.duoxinghaocesuan.length == 0) {
                        this.shengchengflag = true
                    } else if (this.duoxinghaocesuan.length > 1) {
                        this.shengchengflag = false
                    }
                } else {
                    this.$msg.msge("请选择大类和物料再进行确认")
                }
            },

            kankanyichang() {

                this.jianchayichang = true;

            },

            jiazaijieguoxinxi(rd) {

                this.jisuanjilujieguo = [];
                this.jisuanjilujieguostr = '';
                this.xiangxijilujieguo = '';

                this.yichangxinxi = '';


                for (var c in rd.fanhuixinximap) {

                    this.jisuanjilujieguo.push({

                        xuhao: c.split(":")[0],
                        xinxi: c.split(":")[1]

                    })


                    for (var cc in rd.fanhuixinximap[c]) {


                        if (rd.fanhuixinximap[c][cc].search(",") != -1) {

                            for (var f in this.cesuanbiaoshi) {

                                if (this.cesuanbiaoshi[f].code == (rd.fanhuixinximap[c][cc].split(",")[0].split(":")[1].trim())) {

                                    this.jisuanjilujieguo.push({

                                        xuhao: this.cesuanbiaoshi[f].name,
                                        xinxi: rd.fanhuixinximap[c][cc]

                                    })

                                    this.jisuanjilujieguostr += ("项: " + this.cesuanbiaoshi[f].name + " 信息: " + rd.fanhuixinximap[c][cc] + (this.cesuanbiaoshi[
                                        f].des != null ? (" 公式: " + this.cesuanbiaoshi[f].des) : '') + '\n');

                                }

                            }

                        } else {

                            this.jisuanjilujieguostr += (rd.fanhuixinximap[c][cc] + '\n');

                        }


                    }

                }


                for (var c in rd.jisuanjilu) {

                    this.xiangxijilujieguo += (c + rd.jisuanjilu[c] + '\n');

                }


                this.yichangxinxi = rd.tishixinxi;

            },

            jiazaigongshibiao() {
                ss.FormulaNew.gongshibiaolist().then(rd1 => {
                    this.gongshiduizhaobiao = '';
                    for (var c in rd1) {
                        if (rd1[c].type == 'w' || rd1[c].type == 'u') {
                            this.gongshiduizhaobiao += ("公式名: " + rd1[c].proName + (rd1[c].modelName != null && rd1[c].modelName != '' ? (
                                "/" + rd1[c].modelName) : '') + (rd1[c].ratetext != null && rd1[c].ratetext != '' ? (" || 公式信息: " + rd1[c].ratetext) :
                                "") + " || 公式编号: " + rd1[c].formulanum + (rd1[c].formula != null && rd1[c].formula != '' ? (" || 公式: " +
                                rd1[c].formula) : '') + '\n' + '\n');

                        }
                    }
                })
            },

            gongshiduizhaokai() {

                this.gongshiduizhao = true;

            },

            xiangxixinxixianshi() {

                this.xiangxijilu = true;

            },


            xianshijisuanguocheng() {

                this.jisuanjiluxianshi = true;

            },


            panduanxiaoshu() {

                var d = true;


                if (this.shuruhuanjilv && ((parseFloat(this.shuruhuanjilv) != 0 && (/^0.\d+$/.test(this.shuruhuanjilv) == false)) ||
                    (parseFloat(this.shuruhuanjilv) != 0 && parseFloat(this.shuruhuanjilv) > 1))) {

                    this.$msg.msge("百分比请输入小于1的小数")

                    d = false;

                } else {

                    d = true;

                }

                return d;

            },


            // tanchuxuanzeren() {
            //     this.xuanzeren = true;
            //     // dialogFormVisible
            // },

            xuanzeyouxiaoqi(val) {
                console.log(val, '选哦了没')
            },


            //选择使用人
            // shiyongrenxuanze(val) {
            //     console.log(val, '+++使用人')
            //     this.xuanzeren = false;
            //     this.ProMain.xuanzhongren = val.username;
            //     this.ProMain.shiyongren = val.usercode;

            // },


            //查找损益
            quchazhaosunyi() {
                console.log(1234567);
                ss.FormulaHaiwai.chazhaosunyiLk(this.duoxinghaocesuan,1).then(rd => {

                    console.log(rd, '到底null')

                    for (var s in rd.obj) {

                        for (var ss in rd.obj[s]) {

                            //如果后台损益没有值(返回'null'字符串)，就让选填的部分变为可以选填
                            if (rd.obj[s][ss] == 'null') {

                                for (var c = 0; c < this.duoxinghaocesuan.length; c++) {

                                    if (this.tableData[0]['xinghao' + (parseInt(c) + 1)] == s) {


                                        for (var d in this.tableData) {

                                            if (this.tableData[d].canshuxulie == ss) {

                                                switch (ss) {

                                                    case 'w21':


                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;


                                                        // this.tableData[14]['sunyixianshi'+(parseInt(c)+1)] = true;
                                                        break;
                                                    case 'w25':


                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;


                                                        // this.tableData[18]['sunyixianshi'+(parseInt(c)+1)] = true;
                                                        break;

                                                }


                                            }


                                            if (this.tableData[d].hejilvxulie == ss) {

                                                switch (ss) {

                                                    case 'u31':

                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;

                                                        break;

                                                }

                                            }

                                        }


                                    }

                                }

                            }

                        }

                    }


                })

            },


            tableRowClassName(row, index) {

                //若是销售经理
                if (this.shifouxiaoshoujingli) {

                    if (
                        row.rowIndex != 0 &&
                        row.rowIndex != 1 &&
                        row.rowIndex != 2 &&
                        row.rowIndex != 3 &&
                        row.rowIndex != 4 &&
                        row.rowIndex != 6 &&
                        row.rowIndex != 7 &&
                        row.rowIndex != 8 &&
                        row.rowIndex != 9 &&
                        row.rowIndex != 10 &&
                        row.rowIndex != 11 &&
                        row.rowIndex != 12 &&
                        row.rowIndex != 13 &&
                        row.rowIndex != 14 &&
                        row.rowIndex != 23 &&
                        row.rowIndex != 24 &&
                        row.rowIndex != 29 &&
                        row.rowIndex != 31 &&
                        row.rowIndex != 18
                    ) {
                        return 'hidden-row';
                    }
                    return '';
                }

            },


            //前页转发判断
            zhuanfapanduan() {
                //若是有转发信息
                // if (this.$route.query != null) {
                if (JSON.stringify(this.$route.query) != '{}') {
                    //若是审批信息
                    if (this.$route.query.ywid) {
                        console.log(this.$route.query, '看看审批的对象')
                        //ywid
                        this.ywid = this.$route.query.ywid;
                        //instid
                        this.instid = this.$route.query.instid;
                        //taskid
                        this.taskid = this.$route.query.taskid;
                        //计算版本
                        this.rversion = this.$route.query.ywid;
                        //计算版本
                        this.taskstatus = this.$route.query.taskstatus;
                        if(this.taskstatus ==1) {
                            this.yiban = true;
                        }else {
                            this.yiban = false;
                        }
                        console.log(this.taskstatus,"已办还是代办");
                        //是审批页面
                        this.shenpiyemian = true;
                        this.shoucijiaohu = true;
                        this.bianjiOrbohui = false;

                        this.xinzeng = false;

                        this.banbenid = '';
                        this.banbenop = [];
                        this.huidiao();

                        //加载对应历史记录版本
                        this.zaijiajisuanjilu(this.$route.query.ywid);


                    }

                    //特价查看跳转
                    if (this.$route.query.chakanshiti && this.$route.query.chakanshiti != '') {
                        //只读
                        this.zhidumoshi = true;
                        this.xinzeng = false;
                        //计算版本
                        this.rversion = this.$route.query.chakanshiti;
                        var rversion = {
                            rversion: this.$route.query.chakanshiti
                        }
                        //找版本判断instid
                        ss.FormulaNew.getbanben(rversion).then(rd => {
                            //判断instid
                            this.panduaninstid(rd.obj);
                        })
                        this.shoucijiaohu = true;
                        this.banbenid = '';
                        this.banbenop = [];
                        this.huidiao();

                        //首次取值
                        this.zaijiajisuanjilu(this.$route.query.chakanshiti);

                    }
                    //编辑跳转
                    if (this.$route.query.bianjishiti && this.$route.query.bianjishiti != '') {
                        this.shoucijiaohu = true;
                        this.xinzeng = true;

                        this.bianjiOrbohui = false;
                        this.banbenid = '';
                        this.banbenop = [];
                        this.huidiao();
                        //this.rversion = this.$route.query.bianjishiti;
                        //首次取值
                        this.zaijiajisuanjilu(this.$route.query.bianjishiti);

                    }


                    // //若是普通项目转发
                    // else if(this.$route.query.id){
                    //
                    //     //转发的项目信息
                    //     this.qianyexiangmu = this.$route.query;
                    //
                    //     console.log(this.$route.query)
                    //
                    //     //加载项目产品初始化表格的参数项目id
                    //     this.ajaxRequest.fileName = this.$route.query.id;
                    //
                    //     //海外测算参数项目id
                    //     this.proid = this.$route.query.id;
                    //
                    //     //查找计算记录
                    //     this.chazhaojisuanguocheng(this.$route.query.id);
                    //
                    // }

                }

            },


            //加载定价
            jiazaidingjia() {

                console.log(this.ProMain.shiyongren + "this.ProMain.shiyongren");

                var mdmMaterialInfoPrice = {
                    type: this.quyubianma2,
                    usercode: this.ProMain.shiyongren,
                }

                //ss.FormulaHaiwai.huoqudingjia(mdmMaterialInfoPrice).then(rd => {

                   // console.log(rd.obj, '??aa地方都是')

                   // this.dingjialist = rd.obj;

                    //var save = [];

                    //清理掉没有定价的型号
                    // for (var f in this.duoxinghaocesuan) {

                    //     var p = true;

                    //     for (var ff in rd.obj) {

                    //         if (this.duoxinghaocesuan[f] == ff) {

                    //             save.push(this.duoxinghaocesuan[f]);

                    //             p = false;

                    //         }

                    //     }

                    //     if (p) {

                    //         this.$msg.msge(this.duoxinghaocesuan[f] + ":此型号对应使用人区域没有定价")

                    //     }

                    // }


                  //  this.duoxinghaocesuan = save;

                    if (this.duoxinghaocesuan.length == 0) {
                        this.yishengcheng = false;
                    }

                    console.log(this.duoxinghaocesuan,"型号哈哈哈哈")
                    if (this.duoxinghaocesuan.length == 1) {
                        this.shengchengflag = true
                    } else {
                        this.shengchengflag = false
                    }
                 
                    //表格初始化
                    this.biaogechuzhi();

                    //加载默认项
                    this.jiazaicolumndata(this.duoxinghaocesuan)

                    //加载表
                    this.haiwaicesuan(null);

                    this.kaishixuanzeshiyongren = true;

                // })

            },


            //构造计算参数
            gouzaocesuancanshu(q) {

                //构造计算参数
                var entity = {
                    savestatus: q,
                    islengku:1,
                    jsb: null,
                   
                };
              
                var jsb = [];

                for (var s = 0; s < this.duoxinghaocesuan.length; s++) {

                    //必须是有实际物料id才构造参数
                    if (this.duoxinghaocesuan[s] != null && this.duoxinghaocesuan[s] != '') {

                        console.log(this.ProMain.youxiaoqi, '1');
                        jsb.push({
                            "lengku":"1",
                            "lixiangid":  this.ProMain.lixiangid||"", //立项说明附件id
                            "gongjuproname": this.ProMain.gongjuproName||"", //项目名称
                            "w6": this.ProMain.repairtype||"", //保修期

                            "shiyongren":  this.ProMain.shiyongren||"", //使用人usercode

                            "youxiaoqistart": this.ProMain.youxiaoqistart == null ? null : this.ProMain.youxiaoqistart == '0' ? '' :
                                this.ProMain.youxiaoqistart == null ? null : this.ProMain.youxiaoqistart == '0' ? '' : this.$util.riQi(this.ProMain.youxiaoqistart) + "", //特价有效期

                            "validity": this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi == '0' ? '' : this
                                .ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi == '0' ? '' : this.$util.riQi(this.ProMain.youxiaoqi) + "", //特价有效期

                            "xuanzhongren": this.ProMain.xuanzhongren||"", //使用人username

                            "w26": q == null ? "0" : this.tableData[23]['xinghao' + (s + 1)] != null && this.tableData[23]['xinghao' + (s +
                                1)] != '' ? this.tableData[23]['xinghao' + (s + 1)] : '0', //海运费

                            "w13": q == null ? "0" : this.tableData[6]['xinghao' + (s + 1)] != null ? this.tableData[6]['xinghao' + (s + 1)] :
                                '0', //销量
                            "bizhong": q == null ? "USD" : this.tableData[4]['bizhong' + (s + 1)] != null ? this.tableData[4]['bizhong' +
                            (s + 1)
                                ] : 'USD', //币种
                            "w11": q == null ? "0" : this.tableData[4]['xinghao' + (s + 1)] != null ? this.tableData[4]['xinghao' + (s + 1)] :
                                '0', //单台一级供价
                            "dingjiaid": q == null ? "0" : this.tableData[4]['dingjiaid' + (s + 1)] != null ? this.tableData[4][
                            'dingjiaid' + (s + 1)
                                ] : '', //定价id
                            "w7": this.duoxinghaocesuan[s], //物料号
                            "w2": this.quyubianma, //区域
                            "quyubianma2": this.quyubianma2, //定价区域编码
                            "w5": this.ProMain.zhangqi, //账期
                            "u31": q == null ? "0" : this.tableData[28]['u31' + (s + 1)] != null ? this.tableData[28]['u31' + (s + 1)] : '0', //售后换机率
                            "w14": q == null ? "0" : this.tableData[7]['xinghao' + (s + 1)] != null ? this.tableData[7]['xinghao' + (s + 1)] :
                                '0', //申请单价$
                            "w21": q == null ? "0" : this.tableData[18]['xinghao' + (s + 1)] != null ? this.tableData[18]['xinghao' + (s +
                                1)] : '0', //毛利--单台成本
                            "w25": q == null ? "0" : this.tableData[22]['xinghao' + (s + 1)] != null ? this.tableData[22]['xinghao' + (s +
                                1)] : '0', //直接费用--制造费
                            "w27": q == null ? "0" : this.tableData[24]['xinghao' + (s + 1)] != null ? this.tableData[24]['xinghao' + (s +
                                1)] : '0', //保险费
                            "w32": q == null ? "0" : this.tableData[29]['xinghao' + (s + 1)] != null ? this.tableData[29]['xinghao' + (s +
                                1)] : '0', //佣金
                            "w34": q == null ? "0" : this.tableData[31]['xinghao' + (s + 1)] != null ? this.tableData[31]['xinghao' + (s +
                                1)] : '0', //中标服务费

							"p1":q == null ? "0" : this.tableData[8]['xinghao' + (s + 1)] != null ? this.tableData[8]['xinghao' + (s +
									1)] : '0', //运费单台
							"p2":q == null ? "0" : this.tableData[9]['xinghao' + (s + 1)] != null ? this.tableData[9]['xinghao' + (s +
								1)] : '0', //保费单台
							"p3":q == null ? "0" : this.tableData[10]['xinghao' + (s + 1)] != null ? this.tableData[10]['xinghao' + (s +
								1)] : '0', //佣金单台

                            "shifousuibiangai": this.shenpiyemian == true ? "1" : "0", //是不是审批页面(随便改数)，是1  否0

                            //----------------------财务随便改数的----------------------
                            "suibiangai": {

                                "p4":this.tableData[11]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[11]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[11]['xinghao' + (s + 1)] : '0') : 'no', //单台售价

                                "w11": this.tableData[4]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[4]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[4]['xinghao' + (s + 1)] : '0') : 'no', //单台一级供价
                                "w12": this.tableData[5]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[5]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[5]['xinghao' + (s + 1)] : '0') : 'no', //折扣率
                                "w15": this.tableData[12]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[12]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[12]['xinghao' + (s + 1)] : '0') : 'no', //订单金额
                                "w16": this.tableData[13]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[13]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[13]['xinghao' + (s + 1)] : '0') : 'no', //汇率
                                "w17": this.tableData[14]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[14]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[14]['xinghao' + (s + 1)] : '0') : 'no', //订单收入
                                "w18": this.tableData[15]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[15]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[15]['xinghao' + (s + 1)] : '0') : 'no', //材料毛利
                                "w19": this.tableData[16]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[16]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[16]['xinghao' + (s + 1)] : '0') : 'no', //经营贡献
                                "w20": this.tableData[17]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[17]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[17]['xinghao' + (s + 1)] : '0') : 'no', //利润
                                "w21": this.tableData[18]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[18]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[18]['xinghao' + (s + 1)] : '0') : 'no', //单台成本
                                "w22": this.tableData[19]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[19]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[19]['xinghao' + (s + 1)] : '0') : 'no', //成本合计
                                "w23": this.tableData[20]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[20]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[20]['xinghao' + (s + 1)] : '0') : 'no', //材料毛利
                                "w24": this.tableData[21]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[21]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[21]['xinghao' + (s + 1)] : '0') : 'no', //材料毛利率
                                "w25": this.tableData[22]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[22]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[22]['xinghao' + (s + 1)] : '0') : 'no', //制造费用


                                "w28": this.tableData[25]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[25]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[25]['xinghao' + (s + 1)] : '0') : 'no', //港杂费


                                "w29": this.tableData[26]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[26]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[26]['xinghao' + (s + 1)] : '0') : 'no', //商检认证费

                                "w30": this.tableData[27]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[27]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[27]['xinghao' + (s + 1)] : '0') : 'no', //1%免费备件费
                                "w31": this.tableData[28]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[28]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[28]['xinghao' + (s + 1)] : '0') : 'no', //售后换机
                                "w33": this.tableData[30]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[30]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[30]['xinghao' + (s + 1)] : '0') : 'no', //资金成本
                                "w35": this.tableData[32]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[32]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[32]['xinghao' + (s + 1)] : '0') : 'no', //维修基金
                                "w36": this.tableData[33]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[33]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[33]['xinghao' + (s + 1)] : '0') : 'no', //其他税费
                                "w37": this.tableData[34]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[34]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[34]['xinghao' + (s + 1)] : '0') : 'no', //销售人工
                                "w38": this.tableData[35]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[35]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[35]['xinghao' + (s + 1)] : '0') : 'no', //销售组织运营
                                "w39": this.tableData[36]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[36]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[36]['xinghao' + (s + 1)] : '0') : 'no', //研发人工
                                "w40": this.tableData[37]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[37]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[37]['xinghao' + (s + 1)] : '0') : 'no', //研发组织运营
                                "w41": this.tableData[38]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[38]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[38]['xinghao' + (s + 1)] : '0') : 'no', //直接费用小计
                                "w42": this.tableData[39]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[39]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[39]['xinghao' + (s + 1)] : '0') : 'no', //经营贡献
                                "w43": this.tableData[40]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[40]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[40]['xinghao' + (s + 1)] : '0') : 'no', //经营贡献率
                                "w44": this.tableData[41]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[41]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[41]['xinghao' + (s + 1)] : '0') : 'no', //销售费用
                                "w45": this.tableData[42]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[42]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[42]['xinghao' + (s + 1)] : '0') : 'no', //管理费用
                                "w46": this.tableData[43]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[43]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[43]['xinghao' + (s + 1)] : '0') : 'no', //研发费用
                                "w47": this.tableData[44]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[44]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[44]['xinghao' + (s + 1)] : '0') : 'no', //平台费用小计
                                "w48": this.tableData[45]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[45]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[45]['xinghao' + (s + 1)] : '0') : 'no', //利润
                                "w49": this.tableData[46]['shifougaishu' + (s + 1)] == true ? (q == null ? "0" : this.tableData[46]['xinghao' +
                                (s + 1)
                                    ] != null ? this.tableData[46]['xinghao' + (s + 1)] : '0') : 'no', //利润率


                                "u28": this.tableData[47]['shifougaishu' + (s + 1)] == true ? (this.tableData[47]['xinghao' + (s + 1)] != null && this.tableData[47]['xinghao' + (s + 1)] != '' ? this.tableData[47]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的港杂费率
                                "u29": this.tableData[48]['shifougaishu' + (s + 1)] == true ? (this.tableData[48]['xinghao' + (s + 1)] != null && this.tableData[48]['xinghao' + (s + 1)] != '' ? this.tableData[48]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的商检认证费率
                                "u30": this.tableData[49]['shifougaishu' + (s + 1)] == true ? (this.tableData[49]['xinghao' + (s + 1)] != null && this.tableData[49]['xinghao' + (s + 1)] != '' ? this.tableData[49]['xinghao' + (s + 1)] : '0') : 'no',//1%免费备件费
                                "u31": this.tableData[50]['shifougaishu' + (s + 1)] == true ? (this.tableData[50]['xinghao' + (s + 1)] != null && this.tableData[50]['xinghao' + (s + 1)] != '' ? this.tableData[50]['xinghao' + (s + 1)] : '0') : 'no',//售后换机率
                                "u36": this.tableData[51]['shifougaishu' + (s + 1)] == true ? (this.tableData[51]['xinghao' + (s + 1)] != null && this.tableData[51]['xinghao' + (s + 1)] != '' ? this.tableData[51]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的其他税费率
                                "u37": this.tableData[52]['shifougaishu' + (s + 1)] == true ? (this.tableData[52]['xinghao' + (s + 1)] != null && this.tableData[52]['xinghao' + (s + 1)] != '' ? this.tableData[52]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的销售人工费率
                                "u38": this.tableData[53]['shifougaishu' + (s + 1)] == true ? (this.tableData[53]['xinghao' + (s + 1)] != null && this.tableData[53]['xinghao' + (s + 1)] != '' ? this.tableData[53]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的销售组织运费率
                                "u39": this.tableData[54]['shifougaishu' + (s + 1)] == true ? (this.tableData[54]['xinghao' + (s + 1)] != null && this.tableData[54]['xinghao' + (s + 1)] != '' ? this.tableData[54]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的研发人工费率
                                "u40": this.tableData[55]['shifougaishu' + (s + 1)] == true ? (this.tableData[55]['xinghao' + (s + 1)] != null && this.tableData[55]['xinghao' + (s + 1)] != '' ? this.tableData[55]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的研发组织运营费率
                                "u44": this.tableData[56]['shifougaishu' + (s + 1)] == true ? (this.tableData[56]['xinghao' + (s + 1)] != null && this.tableData[56]['xinghao' + (s + 1)] != '' ? this.tableData[56]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-销售费用率
                                "u45": this.tableData[57]['shifougaishu' + (s + 1)] == true ? (this.tableData[57]['xinghao' + (s + 1)] != null && this.tableData[57]['xinghao' + (s + 1)] != '' ? this.tableData[57]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-管理费用率
                                "u46": this.tableData[58]['shifougaishu' + (s + 1)] == true ? (this.tableData[58]['xinghao' + (s + 1)] != null && this.tableData[58]['xinghao' + (s + 1)] != '' ? this.tableData[58]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-研发费用率


                            },


                        })


                    }

                }

                entity.jsb = jsb;


                console.log(entity, '看看参数怎么样')

                return entity;

            },


            //追加多型号
            zhuijiaxinghao(s) {

                if (!this.ProMain.quyu) {

                    this.$msg.msge("请先选区域")

                } else {


                    if (this.duoxinghaocesuan.length >= 15) {

                        this.$msg.msge("最多同时选择15个型号")

                    } else {
                            // if(this.form.dalei || this.form.wuliao){
                                this.duoxinghao = true;

                                this.form.daleiobj = _.find(this.list1, {
                                    oneLid: this.form.dalei
                                });
                                this.form.wuliaoobj = _.find(this.list2, {
                                    prodcode: this.form.wuliao
                                });

                                //多型号的物料编码集
                                if (!s) {

                                    if (this.form.wuliao != null && this.form.wuliao != '') {

                                        this.duoxinghaocesuan.push(this.form.wuliao);

                                        console.log(this.form.wuliao, '看看编号')

                                    }


                                }
                            // }else{
                            //     this.$msg.msge('请选择大类/物料！！！')
                            // }
                        

                                

                                //var p = true;

                                /*for (var c in this.duoxinghaocesuan) {

                                    if (this.duoxinghaocesuan[c] == this.form.wuliao) {

                                        p = false;

                                    }

                                }*/

                                




                    }


                }


            },


            //单型号测算
            danxinghao() {

                //先选区域
                if (!this.ProMain.quyu) {

                    this.$msg.msge("请先选择区域")

                } else {
                    if (this.duoxinghaocesuan.length == 0) {
                        this.$msg.msge('请您先添加测算型号')
                    } else {

                        this.yishengcheng = true;

                        this.zhuijiaxinghao(true);

                        this.duoxinghaotijiao();

                        this.duoxinghao = false;
                    }


                }

            },


            qingkonganniu() {
                this.yishengcheng = false;
                this.huidiao();

            },
            huidiao() {
                this.duoxinghao = false;
                this.duoxinghaocesuan = [];
                this.qingkongchongzhi();

            },


            loadArea(i) {
              
                ss.chanpin.selectLeibie(this.queryq).then(rd => {
                    console.log(this.queryq,'rd1rd1rd1');
                    console.log(rd, 'rdrdrd')
                    this['list' + i] = rd;
                })
            },

            handleItemChange1(val) {
                console.log(val,"梁婕&&&&&&&&&&&&&&&&&&&&&&&");
                this.queryq.pcode = null;
                this.queryq.oneLid = val;
                this.selectWuliao(2);

            },
            selectWuliao(i) {
                ss.chanpin.selectMdmWuliao(this.queryq).then(rd => {
                    console.log(this.queryq);
                    console.log(rd, 'rdrdrd梁婕')
                    this['list' + i] = rd;
                })
           },


            //多型号加载
            duoxinghaotijiao() {

                //必须先选使用人
                // if (this.ProMain.shiyongren == null || this.ProMain.shiyongren == '') {

                //     this.$msg.msge("请先选择使用人")

                // } else {

                    if (this.duoxinghaocesuan.length != 0) {

                        var f = true;

                        for (var c in this.duoxinghaocesuan) {

                            if (this.duoxinghaocesuan[c] == null || this.duoxinghaocesuan[c] == '') {

                                f = false;

                            }

                        }

                        if (!f) {

                            this.$msg.msge("请选择物料");

                        } else if (!this.ProMain.zhangqi) {

                            this.$msg.msge("请选择账期");
                        } else {

                            //清空表
                            this.qingkongchongzhi();

                            if (this.duoxinghaocesuan.length > 0) {

                                //批量加载
                                console.log(this.duoxinghaocesuan, 'asdaseeeewww?')

                                this.yishengcheng = true;

                                //加载定价集
                                this.jiazaidingjia();


                            } else {

                                this.$msg.msge("请先选择要批量测算的物料")

                            }


                        }


                    } else {

                        this.$msg.msge("请先选择物料")

                    }

                // }


            },


            //加载物料号
            jiazaiwuliaohao() {

                ss.FormulaHaiwai.getMarcodeAll().then(rd => {

                    console.log(rd.obj, 'yes')

                    for (var i in rd.obj) {

                        this.wuliaolist.push({
                            label: rd.obj[i],
                            value: i,
                        })
                    }

                })

            },


            //重新提交被驳回的  && this.ProMain.xuanzhongren 
            chongxintijiao() {

                if (!(this.ProMain.quyu && this.ProMain.zhangqi && this.ProMain
                        .youxiaoqi && this.ProMain.youxiaoqistart && this.ProMain.youxiaoqistart != '' && this.ProMain.youxiaoqi != '' &&
                    this.ProMain.youxiaoqistart != 'NaN-NaN-NaN' && this.ProMain.youxiaoqi != 'NaN-NaN-NaN')) {

                    this.$msg.msge("请先填写完整信息")

                } else {

                    this.quchongxintijiao()

                }


            },


            //单保存审批填写信息
            danbaocunshenpi() {
                //点击驳回
                this.tijiaoagain(15);

            },


            //重新提交
            quchongxintijiao() {

                this.tijiaoagain(3);


            },


            //财务暂存19
            caiwuzancun() {

                var entity = this.gouzaocesuancanshu(19);

                entity.rversion = this.rversion;
                console.log(entity.rversion);
                //提交
                ss.FormulaHaiwai.getbyformulahaiwai(entity).then(rd => {

                    this.$msg.msgs("暂存成功");

                    console.log(rd, '暂存信息')

                })

            },


            //再次提交
            tijiaoagain(q) {

                var entity = this.gouzaocesuancanshu(q);

                entity.rversion = this.rversion;

                this.baocunbianliangb = this.rversion;

                //提交
                ss.FormulaHaiwai.getbyformulahaiwai(entity).then(rd => {
                    console.log(q,"是驳回还是重新提交呢11");

                    //成功 并且不是驳回和提交修改
                    if (rd.f == true && q != 15) {
                        if(rd.f == true && q != 13) {
                               console.log(q,"是驳回还是重新提交呢fdfds ");

                                var c = {

                                    rversion: this.rversion,

                                }

                                //删除版本
                                ss.FormulaHaiwai.luojishanchubanben(c).then(rd => {

                                    //跳转
                                    this.shenpitiaozhuan();

                                })
                                }
                             

                    }


                    //如果是驳回先保存成功的
                    if (rd.f == true && q == 15) {
                       console.log(this.yinglishenpi.shenheyijian,"是驳回8888888888888888888888888");
                      
                             //再去驳回
                         this.overshenpi(this.getshenpientity(1), 1);
                    
                        

                    }

                      //如果是驳回先保存成功的
                    if (rd.f == true && q == 13) {
                        //跳转待办
                        this.shenpitiaozhuan();

                    

                    }
                  

                })


            },


            //驳回按钮
            bohuianniu(formname) {

                this.$refs[formname].validate((valid) => {
                    if (valid) {

                        //先保存一个
                        this.danbaocunshenpi();


                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },


            xuanquyu(value) {

                console.log(value)

                //区域码
                this.ProMain.quyu = value.code;

                //区域码xxxx
                this.quyubianma2 = value.des;

                //区域码xx_xx
                this.quyubianma = value.code;

            },


            //通过按钮
            tongguoanniu() {

                //通过审批
                this.overshenpi(this.getshenpientity(2), 2);

            },


            //去审批
            overshenpi(q, n) {
                console.log(q,"驳回原因??");
                ss.FormulaNew.overhaiwaiyinglishenpi(q).then(rd => {

                    if (rd.f == true) {

                        ss.FormulaNew.haiwaidangengxin(rd.obj).then(rd => {

                            if (rd.f == true) {


                                //驳回完事了
                                if (n == 1) {
                                    var rversion = {

                                        rversion: this.baocunbianliangb,

                                    }

                                    ss.FormulaNew.fanzhuanop(rversion).then(rd => {

                                        //跳转待办
                                        this.shenpitiaozhuan();

                                    })

                                } else {

                                    //跳转待办
                                    this.shenpitiaozhuan();

                                }


                            }

                        })


                    }

                })

            },


            //审批实体
            getshenpientity(q) {

                var shenPiEntity = {

                    yewuzhujian: this.rversion, //业务主键

                    taskid: this.taskid, //页面拿到的taskid

                    optflag: q == 2 ? '通过' : "驳回",

                    msg: this.yinglishenpi.shenheyijian, //  页面填写的审核意见

                    tongguoorbohui: q, // 通过还是驳回的flag  1驳回  2通过

                    jiediantiaojianming: 'tongguoorbohui', //通过还是驳回的节点条件名字

                    instid: this.instid, //审批版本id

                }

                return shenPiEntity;

            },


            //跳转待办
            shenpitiaozhuan() {

                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({
                        path: '/personal/dealCenter'
                    })
                })

            },


            cellstyle(value) {

                if (value.rowIndex == 6
                    || value.rowIndex == 7
                    || value.rowIndex == 8
                    || value.rowIndex == 9
                    || value.rowIndex == 10
                    || value.rowIndex == 28
                    || value.rowIndex == 22
                    || value.rowIndex == 31) {

                    return 'color: red;'

                }


            },


            huanjilvxuanze(value) {

                console.log(value, '看看选中的多少')

                this.shuruhuanjilv = this.tableData[28]['u31' + (value)];

                this.keyishuru = true;

            },

            // dingjiaxuanze(value) {

            //     this.showdingjiaoplist = [];

            //     console.log(value, '看看选中的多少')

            //     this.shurudingjia = "原定价:" + this.tableData[4]['xinghao' + (value)];

            //     var marcode = '';

            //     for (var x in this.showdingjiaop) {

            //         if (value == this.showdingjiaop[x].value) {

            //             console.log(this.showdingjiaop[x].marcode, 'marcode看看多少')
            //             marcode = this.showdingjiaop[x].marcode;
            //         }

            //     }

            //     for (var d in this.dingjialist) {

            //         if (d == marcode) {

            //             for (var f in this.dingjialist[d]) {

            //                 this.showdingjiaoplist.push({

            //                     label: this.dingjialist[d][f].currency + ":" + this.dingjialist[d][f].value,
            //                     value: this.dingjialist[d][f].id,
            //                     bizhong: this.dingjialist[d][f].currency,
            //                     dingjia: this.dingjialist[d][f].value,

            //                 })


            //             }

            //         }

            //     }


            //     if (this.showdingjiaoplist.length != 0) {

            //         this.keyixuanze = true;

            //     } else {

            //         this.$msg.msge("此型号没有定价信息")

            //     }


            // },


            dongtaishezhi() {

                console.log(this.huanjilv, "选的哪个")

                console.log(this.shuruhuanjilv, "换机率")

                if (this.shuruhuanjilv) {

                    var d = this.panduanxiaoshu();

                    if (d) {

                        this.tableData[28]['u31' + (this.huanjilv)] = this.shuruhuanjilv;

                    }

                }

            },


            dongtaishezhidingjia(value) {

                for (var c in this.showdingjiaoplist) {

                    if (this.showdingjiaoplist[c].value == value) {

                        this.tableData[4]['xinghao' + (this.dingjiaone)] = this.showdingjiaoplist[c].dingjia;
                        this.tableData[4]['dingjiaid' + (this.dingjiaone)] = value;
                        this.tableData[4]['bizhong' + (this.dingjiaone)] = this.showdingjiaoplist[c].bizhong;

                        console.log(this.showdingjiaoplist[c].dingjia, 'aaw3ww')
                        console.log(this.showdingjiaoplist[c].bizhong, 'ahgndd')

                    }

                }


            },


            shezhihuanjilv() {

                console.log(this.huanjilv, "选的哪个")

                console.log(this.shuruhuanjilv, "换机率")

                if (this.shuruhuanjilv) {

                    var d = this.panduanxiaoshu();

                    if (d) {

                        this.tableData[28]['u31' + (this.huanjilv)] = this.shuruhuanjilv;

                    }

                }

                this.showlv = false;

            },


            shezhidingjia() {

                this.showdingjia = false;

            },


            //售后换机率弹框选择输入
            showlvaction(value) {

                console.log(value, 'row??')

                console.log(this.tableData, 'tableData??')

                for (var s = 0; s < 15; s++) {

                    //如果存在型号
                    if (this.tableData[0]['xinghao' + (parseInt(s) + 1)] != null && this.tableData[0]['xinghao' + (parseInt(s) + 1)] !=
                        '') {


                        for (var d in this.tableData) {

                            if (this.tableData[d].hejilvxulie == 'u31') {

                                //若该型号选填flag是true，才让他选填
                                if (this.tableData[d]['sunyixianshi' + (parseInt(s) + 1)] == true) {

                                    this.showlvop.push({

                                        label: "型号:" + this.tableData[0]['xinghao' + (parseInt(s) + 1)],
                                        value: parseInt(s) + 1,

                                    });

                                }


                            }

                        }

                    }


                }


                this.showlv = true;

            },


            tianjiadingjia() {


                for (var s = 0; s < 15; s++) {

                    //如果存在型号
                    if (this.tableData[0]['xinghao' + (parseInt(s) + 1)] != null && this.tableData[0]['xinghao' + (parseInt(s) + 1)] !=
                        '') {

                        this.showdingjiaop.push({

                            label: "型号:" + this.tableData[0]['xinghao' + (parseInt(s) + 1)],
                            value: parseInt(s) + 1,
                            marcode: this.tableData[0]['xinghao' + (parseInt(s) + 1)],

                        });

                    }


                }


                this.showdingjia = true;

            },


            //提交后的回显处理
            tijiaotiaozhuan(q, rd) {
                //若暂存
                if (q == 0) {
                    //成功
                    if (rd.f == true) {
                        this.$msg.msgs("暂存成功")
                        //跳转
                        this.$router.push("/rvlistshow")
                    } else {
                        this.$msg.msge(rd.msg)
                    }
                    //若提交
                } else if (q == 1) {
                    //成功
                    if (rd.f == true) {
                        this.$msg.msgs("提交成功")
                        //跳转
                        this.$router.push("/rvlistshow")
                    } else {
                        this.$msg.msge(rd.msg)
                    }

                }


            },

            //添加相同型号加载表开始************************************************ 4月8日
            listjiazai(rd) {
                //------------开始加载表信息------------
                //若存在表信息
                if (rd.listResult) {
                    //------------开始加载头部内容------------
                    //写入上头
                    var num = true;
                    this.zonggeshu = 0;
                    //遍历计算结果map
                    for (var r in rd.listResult) {
                        this.zonggeshu++;
                        //需要写入头
                        if (num) {
                            this.ProMain.lixiangid = rd.listResult[r].lixiangid;
                            this.ProMain.gongjuproName = rd.listResult[r].gongjuproname;

                            this.ProMain.quyu = rd.listResult[r].w2;
                            this.ProMain.des = rd.listResult[r].quyubianma2;
                            this.ProMain.zhangqi = rd.listResult[r].w5;

                            if (rd.listResult[r].w6 != null && rd.listResult[r].w6 != 0 && rd.listResult[r].w6 != '0') {

                                this.ProMain.repairtype = rd.listResult[r].w6;

                            }
                            //有效期
                            this.ProMain.youxiaoqistart = rd.listResult[r].youxiaoqistart == '0' ? "" : rd.listResult[r].youxiaoqistart;

                            this.ProMain.youxiaoqi =  rd.listResult[r].validity == '0' ? "" : rd.listResult[r].validity;
                            if (rd.listResult[r].shiyongren != null && rd.listResult[r].shiyongren != '' && rd.listResult[r].shiyongren != '0') {

                                this.ProMain.shiyongren = rd.listResult[r].shiyongren;

                            }
                            // if (rd.listResult[r].xuanzhongren != null && rd.listResult[r].xuanzhongren != '' && rd.listResult[r].xuanzhongren != '0') {

                            //     this.ProMain.xuanzhongren = rd.listResult[r].xuanzhongren;

                            // }
                            //遍历字典把区域码转换成定价码存起来
                            for (var c in this.$store.getters.dicts.haiwaiquyu_cesuan) {

                                if (this.$store.getters.dicts.haiwaiquyu_cesuan[c].code == rd.listResult[r].w2) {
                                    //区域编码--定价
                                    this.quyubianma2 = this.$store.getters.dicts.haiwaiquyu_cesuan[c].des;
                                    //区域编码--测算
                                    this.quyubianma = this.$store.getters.dicts.haiwaiquyu_cesuan[c].code;

                                }

                            }
                            //若都有值了
                            if (rd.listResult[r].w2 && rd.listResult[r].w5) {
                                //就不用再写入了
                                num = false;

                            }

                        }
                        //------------开始加载定价------------
                        console.log(this.quyubianma2, 'this.quyubianma2??')

                        var mdmMaterialInfoPrice = {
                            type: this.quyubianma2,
                            usercode: this.ProMain.shiyongren,
                        }

                        //ss.FormulaHaiwai.huoqudingjia(mdmMaterialInfoPrice).then(rd => {
                            //console.log(rd.obj, '??aa')

                            //this.dingjialist = rd.obj;

                         // var save = [];
                            //清理掉没有定价的型号
                            // for (var f in this.duoxinghaocesuan) {

                            //     var p = true;

                            //     for (var ff in rd.obj) {

                            //         if (this.duoxinghaocesuan[f] == ff) {

                            //             save.push(this.duoxinghaocesuan[f]);

                            //             p = false;

                            //         }
                            //     }
                            //     // if (p) {
                            //     //     this.$msg.msge(this.duoxinghaocesuan[f] + ":此型号没有定价")
                            //     // }
                            // }
                           //this.duoxinghaocesuan = save;
                            if (this.duoxinghaocesuan.length == 0) {
                                this.yishengcheng = false;
                            }
                         //})
                        //------------开始加载表数据------------
                        //遍历产品对应结果键值对 || rrr == 'xuanzhongren'
                        for (var rrr in rd.listResult[r]) {
							console.log(rrr,"////////////////////////////")
							if (
								rrr == 'bizhong'
								|| rrr == 'dingjiaid'
								|| rrr == 'gongjuproname'
								|| rrr == 'lixiangid'
								|| rrr == 'quyubianma2'
								|| rrr == 'shiyongren'
								|| rrr == 'w2'
								|| rrr == 'validity'
								|| rrr == 'uid'
								|| rrr == 'w5'
                                || rrr == 'w6'
								|| rrr == 'w7'
								|| rrr == 'w8'
								|| rrr == 'w9'
								|| rrr == 'w10'
								
								|| rrr == 'youxiaoqistart'
							) {
								rd.listResult[r][rrr] = rd.listResult[r][rrr]
							}else{
								rd.listResult[r][rrr] = parseFloat(rd.listResult[r][rrr]) == '0'?'0':parseFloat(rd.listResult[r][rrr]).toString()
							}
                            //遍历表
                            for (var rrrr in this.tableData) {
                                //若参数序列对应结果key
                                if (this.tableData[rrrr].canshuxulie == rrr) {
                                    //对应表第几个产品的值
                                    this.tableData[rrrr]['xinghao' + (parseInt(r) + 1)] = rd.listResult[r][rrr];
                                }
                                //加载售后换机率 u31
                                if (this.tableData[rrrr].hejilvxulie == "u31" && this.tableData[rrrr].hejilvxulie == rrr) {

                                    this.tableData[rrrr]['u31' + (parseInt(r) + 1)] = rd.listResult[r][rrr];

                                }
                                //加载币种 bizhong
                                if (this.tableData[rrrr].canshuxulie == "w11" && rrr == "bizhong") {
                                    this.tableData[rrrr]['bizhong' + (parseInt(r) + 1)] = rd.listResult[r][rrr];
                                    //定价名加上币种
                                    this.tableData[rrrr].coding = '单台一级供价' + rd.listResult[r][rrr];
                                }
                                //单价加上币种
                                if (this.tableData[rrrr].canshuxulie == "w14" && rrr == "bizhong") {
                                    //单价加上币种
                                    this.tableData[rrrr].coding = '申请单价' + rd.listResult[r][rrr] + "(FOB)";

                                }
                                //订单金额加上币种
                                if (this.tableData[rrrr].canshuxulie == "w15" && rrr == "bizhong") {
                                    //订单金额加上币种
                                    this.tableData[rrrr].coding = '订单金额' + rd.listResult[r][rrr];
                                }
                                //------2020-3-4 ---新增

                                //运费单台加上币种
                                if (this.tableData[rrrr].canshuxulie == "p1" && rrr == "bizhong") {

                                    this.tableData[rrrr].coding = '运费' + rd.listResult[r][rrr] + "(单台)";

                                }
                                //保费单台加上币种
                                if (this.tableData[rrrr].canshuxulie == "p2" && rrr == "bizhong") {

                                    this.tableData[rrrr].coding = '保费' + rd.listResult[r][rrr] + "(单台)";

                                }

                                //佣金单台加上币种
                                if (this.tableData[rrrr].canshuxulie == "p3" && rrr == "bizhong") {

                                    this.tableData[rrrr].coding = '佣金' + rd.listResult[r][rrr] + "(单台)";

                                }
                                //单台售价加上币种
                                if (this.tableData[rrrr].canshuxulie == "p4" && rrr == "bizhong") {

                                    this.tableData[rrrr].coding = '单台售价' + rd.listResult[r][rrr];

                                }
                                //------------------
                                //针对唯一定价的加载
                                // for (var ff in this.dingjialist) {

                                //     if (this.tableData[rrrr].canshuxulie == "w7" && ff == this.tableData[rrrr]['xinghao' + (parseInt(r) + 1)]) {

                                //         //有且仅有一个定价
                                //         if (this.dingjialist[ff].length == 1) {


                                //             if (this.tableData[4]['shifougaishu' + (parseInt(r) + 1)] == false) {

                                //                 //直接赋值
                                //                 this.tableData[4]['xinghao' + (parseInt(r) + 1)] = this.dingjialist[ff][0].value;

                                //             }

                                //             //定价id
                                //              //this.tableData[4]['dingjiaid' + (parseInt(r) + 1)] = this.dingjialist[ff][0].id;
                                //             this.tableData[4]['dingjiaid' + (parseInt(r) + 1)] = this.dingjialist[ff][0].id;


                                //         }

                                //     }

                                // }

                                //加载定价
                                if (this.tableData[rrrr].canshuxulie == "w11" && rrr == "w11") {

                                    this.tableData[rrrr]['xinghao' + (parseInt(r) + 1)] = rd.listResult[r][rrr];

                                }


                            }

                        }





                    }

                    console.log(this.tableData, 'tableData循环listResult结束')

                }

                //------------开始加载表合计额率------------
                this.jiazaizonglilv(rd.allrate);
                //------------开始加载表下部否达到盈利目标------------
                if (rd.allrate) {
                    //比较毛利率
                    this.shifoudadaoyinglimubiao(rd.allrate);
                }

                //查找损益
                this.quchazhaosunyi();
                if (this.jisuancishu == 0) {
                    //多存一个tableData
                    this.baocuntable = this.clone(this.tableData);

                }

            },
           //添加相同型号加载表结束************************************************
            //加载表
            jiazaibiao(rd) {
                console.log(rd,"测试显示表");

                //------------开始加载表信息------------

                //若存在表信息
                if (rd.result) {


                    //------------开始加载头部内容------------

                    //写入上头
                    var num = true;

                    this.zonggeshu = 0;

                    //遍历计算结果map    || rrr == 'xuanzhongren'
                    for (var r in rd.result) {
						for(var rrr in rd.result[r]){
                            if (
                                rrr == 'bizhong'
                                || rrr == 'dingjiaid'
                                || rrr == 'gongjuproname'
                                || rrr == 'lixiangid'
                                || rrr == 'quyubianma2'
                                || rrr == 'shiyongren'
                                || rrr == 'w2'
                                || rrr == 'validity'
                                || rrr == 'uid'
                                || rrr == 'w5'
                                || rrr == 'w6'
                                || rrr == 'w7'
                                || rrr == 'w8'
                                || rrr == 'w9'
                                || rrr == 'w10'
                               
                                || rrr == 'youxiaoqistart'
                            ) {
                                rd.result[r][rrr] = rd.result[r][rrr]
                            }else{
                                rd.result[r][rrr] = parseFloat(rd.result[r][rrr]) == '0'?'0':parseFloat(rd.result[r][rrr]).toString()
                            }
                        }
                        this.zonggeshu++;

                        //需要写入头
                        if (num) {


                            this.ProMain.lixiangid = rd.result[r].lixiangid;
                            this.ProMain.gongjuproName = rd.result[r].gongjuproname;


                            this.ProMain.quyu = rd.result[r].w2;
                            this.ProMain.des = rd.result[r].quyubianma2;
                            this.ProMain.zhangqi = rd.result[r].w5;

                            if (rd.result[r].w6 != null && rd.result[r].w6 != 0 && rd.result[r].w6 != '0') {

                                this.ProMain.repairtype = rd.result[r].w6;

                            }

                            this.ProMain.youxiaoqistart = rd.result[r].youxiaoqistart == '0' ? "" : rd.result[r].youxiaoqistart;
                            this.ProMain.youxiaoqi =  rd.result[r].validity == '0' ? "" : rd.result[r].validity;

                            if (rd.result[r].shiyongren != null && rd.result[r].shiyongren != '' && rd.result[r].shiyongren != '0') {

                                this.ProMain.shiyongren = rd.result[r].shiyongren;

                            }

                            // if (rd.result[r].xuanzhongren != null && rd.result[r].xuanzhongren != '' && rd.result[r].xuanzhongren != '0') {

                            //     this.ProMain.xuanzhongren = rd.result[r].xuanzhongren;

                            // }


                            //遍历字典把区域码转换成定价码存起来
                            for (var c in this.$store.getters.dicts.haiwaiquyu_cesuan) {

                                if (this.$store.getters.dicts.haiwaiquyu_cesuan[c].code == rd.result[r].w2) {

                                    //区域编码--定价
                                    this.quyubianma2 = this.$store.getters.dicts.haiwaiquyu_cesuan[c].des;

                                    //区域编码--测算
                                    this.quyubianma = this.$store.getters.dicts.haiwaiquyu_cesuan[c].code;

                                }

                            }


                            //若都有值了
                            if (rd.result[r].w2 && rd.result[r].w5) {

                                //就不用再写入了
                                num = false;

                            }

                        }


                        //------------开始加载定价------------

                        console.log(this.quyubianma2, 'this.quyubianma2??')

                        var mdmMaterialInfoPrice = {
                            type: this.quyubianma2,
                            usercode: this.ProMain.shiyongren,
                        }

                        //ss.FormulaHaiwai.huoqudingjia(mdmMaterialInfoPrice).then(rd => {

                            console.log(rd.obj, '??aa')

                            //this.dingjialist = rd.obj;

                           // var save = [];

                            //清理掉没有定价的型号
                            // for (var f in this.duoxinghaocesuan) {

                            //     var p = true;

                            //     for (var ff in rd.obj) {

                            //         if (this.duoxinghaocesuan[f] == ff) {

                            //             save.push(this.duoxinghaocesuan[f]);

                            //             p = false;

                            //         }

                            //     }

                            //     if (p) {

                            //         this.$msg.msge(this.duoxinghaocesuan[f] + ":此型号没有定价")

                            //     }

                            // }

                            //this.duoxinghaocesuan = save;

                            if (this.duoxinghaocesuan.length == 0) {
                                this.yishengcheng = false;
                            }

                        //})


                        //------------开始加载表数据------------

                        //遍历产品id
                        for (var rr in this.duoxinghaocesuan) {

                            //如果产品id与map的key产品id一致
                            if (r == this.duoxinghaocesuan[rr]) {
                                //遍历产品对应结果键值对
                                for (var rrr in rd.result[r]) {
                                    //遍历表
                                    for (var rrrr in this.tableData) {
                                        //若参数序列对应结果key
                                        if (this.tableData[rrrr].canshuxulie == rrr) {
                                            //对应表第几个产品的值
                                            this.tableData[rrrr]['xinghao' + (parseInt(rr) + 1)] = rd.result[r][rrr];

                                        }

                                        //加载售后换机率 u31
                                        if (this.tableData[rrrr].hejilvxulie == "u31" && this.tableData[rrrr].hejilvxulie == rrr) {

                                            this.tableData[rrrr]['u31' + (parseInt(rr) + 1)] = rd.result[r][rrr];

                                        }

                                        //加载币种 bizhong
                                        if (this.tableData[rrrr].canshuxulie == "w11" && rrr == "bizhong") {
                                            this.tableData[rrrr]['bizhong' + (parseInt(rr) + 1)] = rd.result[r][rrr];
                                            //定价名加上币种
                                            this.tableData[rrrr].coding = '单台一级供价' + rd.result[r][rrr];
                                        }

                                        //单价加上币种
                                        if (this.tableData[rrrr].canshuxulie == "w14" && rrr == "bizhong") {
                                            //单价加上币种
                                            this.tableData[rrrr].coding = '申请单价' + rd.result[r][rrr] + "(FOB)";

                                        }

                                        //订单金额加上币种
                                        if (this.tableData[rrrr].canshuxulie == "w15" && rrr == "bizhong") {
                                            //订单金额加上币种
                                            this.tableData[rrrr].coding = '订单金额' + rd.result[r][rrr];

                                        }


                                        //------2020-3-4 ---新增

                                        //运费单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p1" && rrr == "bizhong") {
                                            this.tableData[rrrr].coding = '运费' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //保费单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p2" && rrr == "bizhong") {
                                            this.tableData[rrrr].coding = '保费' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //佣金单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p3" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '佣金' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //单台售价加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p4" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '单台售价' + rd.result[r][rrr];

                                        }

                                        //------------------
                                        //针对唯一定价的加载
                                        // for (var ff in this.dingjialist) {
                                        //     if (this.tableData[rrrr].canshuxulie == "w7" && ff == this.tableData[rrrr]['xinghao' + (parseInt(rr) + 1)]) {
                                        //         //有且仅有一个定价
                                        //         if (this.dingjialist[ff].length == 1) {
                                        //             if (this.tableData[4]['shifougaishu' + (parseInt(rr) + 1)] == false) {
                                        //                 //直接赋值
                                        //                 this.tableData[4]['xinghao' + (parseInt(rr) + 1)] = this.dingjialist[ff][0].value;
                                        //             }

                                        //             //定价id
                                        //             this.tableData[4]['dingjiaid' + (parseInt(rr) + 1)] = this.dingjialist[ff][0].id;
                                        //         }
                                        //     }
                                        // }
                                        //加载定价
                                        if (this.tableData[rrrr].canshuxulie == "w11" && rrr == "w11") {

                                            this.tableData[rrrr]['xinghao' + (parseInt(rr) + 1)] = rd.result[r][rrr];

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                //------------开始加载表合计额率------------
                this.jiazaizonglilv(rd.allrate);


                //------------开始加载表下部否达到盈利目标------------

                if (rd.allrate) {

                    //比较毛利率
                    this.shifoudadaoyinglimubiao(rd.allrate);

                }


                //查找损益
                this.quchazhaosunyi();


                if (this.jisuancishu == 0) {

                    //多存一个tableData
                    this.baocuntable = this.clone(this.tableData);

                }


            },

            //加载总利率
            jiazaizonglilv(q) {
                        console.log(q,"士大夫艰苦反抗类毒素解放考虑将来的事");
                //存在总额
                if (q) {
                    //订单金额和
                    var w15 = q.w15;
                    //销量和
                    var w13 = q.w13;
                    //成本合计和
                    var w22 = q.w22;
                    //材料毛利和
                    var w23 = q.w23;
                    //订单收入和
                    var w17 = q.w17;
                    //经营贡献和
                    var w42 = q.w42;
                    //利润和
                    var w48 = q.w48;
                    //材料毛利率和
                    var w24 = q.w24;
                    //遍历总额
                    for (var c in q) {
                        //遍历表
                        for (var ccc in this.tableData) {
                            //若参数序列对应结果key
                            if (this.tableData[ccc].hejilvxulie == c) {
                                //对应合计额等于键值对的值
                                this.tableData[ccc].hejiL = q[c];
                            }
                            //若参数序列对应结果key
                            if (this.tableData[ccc].canshuxulie == c) {
                                //对应合计额等于键值对的值
                                this.tableData[ccc].hejiE = q[c];
                                //制造费率  海运费率  保险费率  佣金费率  资金成本费率  中标服务费率  维修基金费率  直接费用小计费率  免费备件费  售后换机  其他税费  销售人工  销售组织运营  研发人工   研发组织运营  平台费用
                                this.divfangfa(c, 'w25', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w26', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w27', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w32', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w33', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w34', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w35', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w41', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w30', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w31', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w36', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w37', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w38', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w39', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w40', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w44', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w45', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w46', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w47', ccc, 'hejiL', q[c], w17);
                                //w11单台一级供价  w12折扣率  取平均值  w16汇率
                                this.divfangfa(c, 'w11', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'w12', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'w12', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'w16', ccc, 'hejiE', q[c], q.savenum);
                                //w14申请单价
                                // this.divfangfa(c, 'w14', ccc, 'hejiE', w15, w13);
                                this.divfangfa(c, 'w14', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p1', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p2', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p3', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p4', ccc, 'hejiE', q[c], q.savenum);
                                //w21单台成本
                                this.divfangfa(c, 'w21', ccc, 'hejiE', w22, w13);
                                //w43经营贡献率
                                this.divfangfa(c, 'w43', ccc, 'hejiE', w42, w17);
                                //w43经营贡献率
                                this.divfangfa(c, 'w43', ccc, 'hejiL', w42, w17);
                                //w42
                                this.divfangfa(c, 'w42', ccc, 'hejiL', w42, w17);
                                //w49利润率
                                this.divfangfa(c, 'w49', ccc, 'hejiE', w48, w17);
                                //w49利润率
                                this.divfangfa(c, 'w49', ccc, 'hejiL', w48, w17);
                                //w48
                                this.divfangfa(c, 'w48', ccc, 'hejiL', w48, w17);
                                //w22
                                this.divfangfa(c, 'w22', ccc, 'hejiL', w22, w17);

                                //w23
                                this.divfangfa(c, 'w23', ccc, 'hejiL', w23, w17);
                                // //w24材料毛利率
                                // this.divfangfa(c, 'w24', ccc, 'hejiE', w23, w17);
                                //
                                // //w24
                                // this.divfangfa(c, 'w24', ccc, 'hejiL', w23, w17);

                                //w24材料毛利率
                                this.divfangfa(c, 'w24', ccc, 'hejiE', w24, this.zonggeshu);
                                //w24
                                this.divfangfa(c, 'w24', ccc, 'hejiL', w24, this.zonggeshu);
                                //w18
                                this.divfangfa(c, 'w18', ccc, 'hejiL', w23, w17);
                                //w19
                                this.divfangfa(c, 'w19', ccc, 'hejiL', w42, w17);
                                //w20
                                this.divfangfa(c, 'w20', ccc, 'hejiL', w48, w17);


                                 //其他计算参数
                                this.divfangfa(c, 'u28', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u29', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u30', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u31', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u36', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u37', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u38', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u39', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u40', ccc, 'hejiL', q[c], q.savenum);

                                this.divfangfa(c, 'u44', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u45', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'u46', ccc, 'hejiL', q[c], q.savenum);

                            }


                        }

                    }

                }

            },


            divfangfa(c, c1, ccc, heji, z, z1) {

                if (c == c1) {
                    if (z != '' && z1 != '' && z != 0 && z1 != 0) {
                        this.tableData[ccc][heji] = (new big(parseFloat(z)).div(parseFloat(z1)).toString());
                    } else {
                        this.tableData[ccc][heji] = 0;
                    }
                }
            },


            //深拷贝递归
            clone(o) {
                var temp = {};
                for (var k in o) {
                    if (typeof o[k] == 'object') {
                        temp[k] = this.clone(o[k]);
                    } else {
                        temp[k] = o[k];
                    }
                }
                return temp;
            },

            //清空信息
            qingkongchongzhi() {
                //计算前清空上次的计算过程
                this.rateFormulaRenewVer = {};
                this.xianshinage = 9;
                this.jingyinggongxiangzong = 0;
                this.lirunzong = 0;
                this.zongmaolilvbiao = 0;
                this.zongmaolilv = 0;
                this.haiwaixiangmuchanpin = [];
                this.columndata = [];
                this.biaogechuzhi();

            },


            //判断表内值
            panduantable() {

                var yes = false;

                for (var d = 1; d < 16; d++) {

                    //看看第几个型号存在
                    if (this.tableData[0]['xinghao' + d] != null && this.tableData[0]['xinghao' + d] != '' && this.tableData[0][
                    'xinghao' + d
                        ] != '0' && this.tableData[0]['xinghao' + d] != '0.0') {

                        //遍历找到对应第几个型号的销量或单价
                        for (var s in this.tableData) {

                            //销量 申请单价
                            if (this.tableData[s].canshuxulie == 'w13' || this.tableData[s].canshuxulie == 'w14') {

                                //如果有没填值的就返回true
                                if (this.tableData[s]['xinghao' + d] == null || this.tableData[s]['xinghao' + d] == '' || this.tableData[s][
                                'xinghao' + d
                                    ] == '0' || this.tableData[s]['xinghao' + d] == 0 || this.tableData[s]['xinghao' + d] == 0.0 || this.tableData[
                                    s]['xinghao' + d] == '0.0') {
                                    yes = true;
                                }

                            }

                        }

                    }


                }

                return yes;

            },


            //海外测算
            haiwaicesuan(q) {

                //暂存或者提交  && this.ProMain.xuanzhongren
                if ((q == 0 || q == 1) && (!(this.ProMain.lixiangid &&this.ProMain.gongjuproName &&this.ProMain.repairtype && this.ProMain.quyu && this.ProMain.zhangqi  &&
                    this.ProMain.youxiaoqi && this.ProMain.youxiaoqistart) || (this.ProMain.youxiaoqistart ==
                    null || this.ProMain.youxiaoqi == null || this.ProMain.youxiaoqistart == '' || this.ProMain.youxiaoqi == '' ||
                    this.ProMain.youxiaoqistart == 'NaN-NaN-NaN' || this.ProMain.youxiaoqi == 'NaN-NaN-NaN' || this.panduantable()))) {

                    this.$msg.msge("请先填写完整信息")

                } else if(this.duoxinghaocesuan.length == 0) {
                    this.$msg.msge("请先选择物料");
                }else {

                    this.qucesuan(q);

                }


            },


            qucesuan(q) {

                var c = true;

                //确认一下定价都有没有
                for (var d in this.duoxinghaocesuan) {

                    if (!this.tableData[4]['xinghao' + (parseInt(d) + 1)]) {

                        c = false;
                    }

                }

                if (q != null && q != 0 && !c) {

                    this.$msg.msge("请先选择定价")

                } else {

                    this.cesuanfangfa(this.gouzaocesuancanshu(q));

                }

            },


            //测算方法
            cesuanfangfa(q) {
                     q.rversion = this.$route.query.bianjishiti;
                     console.log(q.rversion,"你好，我是你要的");
                // //弹窗选择使用人和有效期
                // this.xuanzeshiyongren = true;

                ss.FormulaHaiwai.getbyformulahaiwai(q).then(rd => {


                    //回显
                    this.tijiaotiaozhuan(q.savestatus, rd)

                    console.log(rd, "看看有没有***")


                    this.jiazaijieguoxinxi(rd);


                     if (rd.yes != null && rd.yes == true) {

                        //新的解析加载，添加相同型号
                        this.listjiazai(rd);

                        console.log("1")

                    } else {

                        //加载表
                        this.jiazaibiao(rd);

                        console.log("2")

                    }

                    //若这次测算的保存版本存在
                    if (rd.rateFormulaRenewVer) {

                        //本次计算版本id
                        this.rversion = rd.rateFormulaRenewVer.rversion;

                    }

                })

            },


            //表格初始化
            biaogechuzhi() {
                this.tableData = [{
                    message: '基本信息',
                    coding: '编码',
                    shuoming: '',
                    biaozhun: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
                    xinghao6: '',
                    xinghao7: '',
                    xinghao8: '',
                    xinghao9: '',
                    xinghao10: '',
                    xinghao11: '',
                    xinghao12: '',
                    xinghao13: '',
                    xinghao14: '',
                    xinghao15: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
                    flags6: false,
                    flags7: false,
                    flags8: false,
                    flags9: false,
                    flags10: false,
                    flags11: false,
                    flags12: false,
                    flags13: false,
                    flags14: false,
                    flags15: false,
                    canshuxulie: 'w7',
                    hejilvxulie: '',
                    //0
                }, {
                    coding: '型号',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
                    xinghao6: '',
                    xinghao7: '',
                    xinghao8: '',
                    xinghao9: '',
                    xinghao10: '',
                    xinghao11: '',
                    xinghao12: '',
                    xinghao13: '',
                    xinghao14: '',
                    xinghao15: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
                    flags6: false,
                    flags7: false,
                    flags8: false,
                    flags9: false,
                    flags10: false,
                    flags11: false,
                    flags12: false,
                    flags13: false,
                    flags14: false,
                    flags15: false,
                    canshuxulie: 'w8',
                    hejilvxulie: '',
                    //1
                }, {
                    coding: '产品大类',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
                    xinghao6: '',
                    xinghao7: '',
                    xinghao8: '',
                    xinghao9: '',
                    xinghao10: '',
                    xinghao11: '',
                    xinghao12: '',
                    xinghao13: '',
                    xinghao14: '',
                    xinghao15: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
                    flags6: false,
                    flags7: false,
                    flags8: false,
                    flags9: false,
                    flags10: false,
                    flags11: false,
                    flags12: false,
                    flags13: false,
                    flags14: false,
                    flags15: false,
                    canshuxulie: 'w9',
                    hejilvxulie: '',
                    //2
                }, {
                    coding: '产品系列',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',

                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
                    xinghao6: '',
                    xinghao7: '',
                    xinghao8: '',
                    xinghao9: '',
                    xinghao10: '',
                    xinghao11: '',
                    xinghao12: '',
                    xinghao13: '',
                    xinghao14: '',
                    xinghao15: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
                    flags6: false,
                    flags7: false,
                    flags8: false,
                    flags9: false,
                    flags10: false,
                    flags11: false,
                    flags12: false,
                    flags13: false,
                    flags14: false,
                    flags15: false,
                    canshuxulie: 'w10',
                    hejilvxulie: '',
                    //3
                },
                    {
                        message: '收入',
                        coding: '单台一级供价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w11',
                        hejilvxulie: '',

                        dingjia1: '',
                        dingjia2: '',
                        dingjia3: '',
                        dingjia4: '',
                        dingjia5: '',
                        dingjia6: '',
                        dingjia7: '',
                        dingjia8: '',
                        dingjia9: '',
                        dingjia10: '',
                        dingjia11: '',
                        dingjia12: '',
                        dingjia13: '',
                        dingjia14: '',
                        dingjia15: '',

                        dingjiaid1: '',
                        dingjiaid2: '',
                        dingjiaid3: '',
                        dingjiaid4: '',
                        dingjiaid5: '',
                        dingjiaid6: '',
                        dingjiaid7: '',
                        dingjiaid8: '',
                        dingjiaid9: '',
                        dingjiaid10: '',
                        dingjiaid11: '',
                        dingjiaid12: '',
                        dingjiaid13: '',
                        dingjiaid14: '',
                        dingjiaid15: '',

                        bizhong1: '',
                        bizhong2: '',
                        bizhong3: '',
                        bizhong4: '',
                        bizhong5: '',
                        bizhong6: '',
                        bizhong7: '',
                        bizhong8: '',
                        bizhong9: '',
                        bizhong10: '',
                        bizhong11: '',
                        bizhong12: '',
                        bizhong13: '',
                        bizhong14: '',
                        bizhong15: '',

                        //4
                    }, {
                        coding: '折扣率',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w12',
                        hejilvxulie: '',
                        //5
                    },
                    {
                        coding: '销量',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w13',
                        hejilvxulie: '',
                        //6
                    },
                    {
                        coding: '申请单价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'shenqingdanjia',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w14',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //7
                    },


                    {
                        coding: '运费(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'yunfeidantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p1',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //8
                    },

                    {
                        coding: '保费(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'baofeidantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p2',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //9
                    },


                    {
                        coding: '佣金(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'yongjindantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p3',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //10
                    },


                    {
                        coding: '单台售价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'dantaishoujia',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p4',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //11
                    },


                    {
                        coding: '订单金额',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w15',
                        hejilvxulie: '',
                        //12
                    },
                    {
                        coding: '汇率',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w16',
                        hejilvxulie: '',
                        //13
                    },
                    {
                        coding: '订单收入￥',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w17',
                        hejilvxulie: '',
                        //14
                    },

                    {
                        message: '盈利情况',
                        coding: '材料毛利',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w18',
                        hejilvxulie: '',
                        //15
                    },
                    {
                        coding: '经营贡献',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w19',
                        hejilvxulie: '',
                        //16
                    },
                    {
                        coding: '利润',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w20',
                        hejilvxulie: '',
                        //17
                    },
                    {
                        message: '毛利',
                        coding: '单台成本',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w21',
                        hejilvxulie: '',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
                        //18
                    },
                    {
                        coding: '成本合计',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w22',
                        hejilvxulie: '',
                        //19
                    },
                    {
                        coding: '材料毛利',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w23',
                        hejilvxulie: '',
                        //20
                    },
                    {
                        coding: '材料毛利率',
                        biaozhun: '',
                        hejiL: '',
                        shuoming: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w24',
                        hejilvxulie: '',
                        //21
                    },
                    {
                        message: '直接费用',
                        coding: '制造费用',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w25',
                        hejilvxulie: '',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
                        sunyixianshi6: false,
                        sunyixianshi7: false,
                        sunyixianshi8: false,
                        sunyixianshi9: false,
                        sunyixianshi10: false,
                        sunyixianshi11: false,
                        sunyixianshi12: false,
                        sunyixianshi13: false,
                        sunyixianshi14: false,
                        sunyixianshi15: false,
                        //22
                    },

                    {
                        message: '直接费用',
                        coding: '海运费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w26',
                        hejilvxulie: 'u26',
                        //23
                    },

                    {
                        message: '直接费用',
                        coding: '保险费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w27',
                        hejilvxulie: '',
                        //24
                    },

                    {

                        coding: '港杂费',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w28',
                        hejilvxulie: 'u28',
                        //25
                    },
                    {
                        coding: '商检认证费',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w29',
                        hejilvxulie: 'u29',
                        //26
                    },
                    {
                        coding: '售后费用',
                        shuoming: '1%免费备件费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w30',
                        hejilvxulie: 'u30',
                        //27
                    },
                    {
                        coding: '售后费用',
                        shuoming: '售后换机',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        u311: '',
                        u312: '',
                        u313: '',
                        u314: '',
                        u315: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w31',
                        hejilvxulie: 'u31',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
                        sunyixianshi6: false,
                        sunyixianshi7: false,
                        sunyixianshi8: false,
                        sunyixianshi9: false,
                        sunyixianshi10: false,
                        sunyixianshi11: false,
                        sunyixianshi12: false,
                        sunyixianshi13: false,
                        sunyixianshi14: false,
                        sunyixianshi15: false,
                        //28
                    },
                    {
                        coding: '售后费用',
                        shuoming: '佣金(CNY)',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w32',
                        hejilvxulie: '',

                        //29
                    },
                    {
                        coding: '资金成本',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w33',
                        hejilvxulie: '',
                        //30
                    },
                    {
                        coding: '中标服务费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'zhongbiaofuwufei',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w34',
                        marcode1: '',
                        marcode2: '',
                        marcode3: '',
                        marcode4: '',
                        marcode5: '',
                        marcode6: '',
                        marcode7: '',
                        marcode8: '',
                        marcode9: '',
                        marcode10: '',
                        marcode11: '',
                        marcode12: '',
                        marcode13: '',
                        marcode14: '',
                        marcode15: '',
                        hejilvxulie: '',
                        //31
                    },

                    {
                        coding: '税费',
                        shuoming: '维修基金',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w35',
                        hejilvxulie: '',
                        //32
                    },
                    {
                        coding: '',
                        shuoming: '其他税费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w36',
                        hejilvxulie: 'u36',
                        //33
                    },

                    {
                        coding: '销售费用',
                        shuoming: '销售人工',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w37',
                        hejilvxulie: 'u37',
                        //34
                    },
                    {
                        coding: '',
                        shuoming: '销售组织运营',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w38',
                        hejilvxulie: 'u38',
                        //35
                    },
                    {
                        coding: '研发费用',
                        shuoming: '研发人工',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w39',
                        hejilvxulie: 'u39',
                        //36
                    },
                    {
                        coding: '',
                        shuoming: '研发组织运营',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w40',
                        hejilvxulie: 'u40',
                        //37
                    },
                    {
                        coding: '直接费用小计',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w41',
                        hejilvxulie: '',
                        //38
                    },
                    {
                        message: '经营贡献',
                        coding: '经营贡献',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w42',
                        hejilvxulie: '',
                        //39
                    },
                    {
                        coding: '经营贡献率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '0',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w43',
                        hejilvxulie: '',
                        //40
                    },
                    {
                        message: '平台费用',
                        coding: '销售费用',
                        shuoming: '自产费用率',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w44',
                        hejilvxulie: 'u44',
                        //41
                    },
                    {
                        coding: '管理费用',
                        shuoming: '全部产品费用率',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w45',
                        hejilvxulie: 'u45',
                        //42
                    },
                    {
                        coding: '研发费用',
                        shuoming: '自产研发费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w46',
                        hejilvxulie: 'u46',
                        //43
                    },
                    {
                        coding: '平台费用小计',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w47',
                        hejilvxulie: 'u47',
                        //44
                    },
                    {
                        message: '利润',
                        coding: '利润',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w48',
                        hejilvxulie: '',
                        //45
                    },
                    {
                        coding: '利润率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '0',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'w49',
                        hejilvxulie: '',
                        //46
                    },
                    {
                        message: '其他计算参数',
                        coding: '项目所属区域的港杂费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u28',
                        hejilvxulie: 'u28',
                        //47
                    },
                    {
                        coding: '项目所属区域的商检认证费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u29',
                        hejilvxulie: 'u29',
                        //48
                    },
                    {
                        coding: '1%免费备件费',
                        shuoming: '物料表取产品组department如果是ND，就是非自产，其他自产  自产产品费率为1%，非自产为0',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u30',
                        hejilvxulie: 'u30',
                        //49
                    },
                    {
                        coding: '售后换机率',
                        shuoming: '物料表PRODUCT_HIERARCHY截取前三位去损益表查PROD_CODE且ACT_CODE是A02390的    如果平台没有可以手填  小数',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u31',
                        hejilvxulie: 'u31',

                        //50
                    },


                    {
                        coding: '项目所属产品的其他税费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u36',
                        hejilvxulie: 'u36',
                        //51
                    },

                    {
                        coding: '项目所属区域的销售人工费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u37',
                        hejilvxulie: 'u37',
                        //52
                    },
                    {
                        coding: '项目所属区域的销售组织运费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u38',
                        hejilvxulie: 'u38',
                        //53
                    },
                    {
                        coding: '项目所属产品的研发人工费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u39',
                        hejilvxulie: 'u39',
                        //54
                    },
                    {
                        coding: '项目所属产品的研发组织运营费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u40',
                        hejilvxulie: 'u40',
                        //55
                    },


                    {
                        coding: '项目所属产品的平台费用-销售费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u44',
                        hejilvxulie: 'u44',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        //56
                    },
                    {
                        coding: '项目所属产品的平台费用-管理费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u45',
                        hejilvxulie: 'u45',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        //57
                    },
                    {
                        coding: '项目所属产品的平台费用-研发费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        canshuxulie: 'u46',
                        hejilvxulie: 'u46',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        //58
                    },
                ]


                //增加默认属性  财务改数flag
                for (var d in this.tableData) {

                    this.tableData[d].shifougaishu1 = false;
                    this.tableData[d].shifougaishu2 = false;
                    this.tableData[d].shifougaishu3 = false;
                    this.tableData[d].shifougaishu4 = false;
                    this.tableData[d].shifougaishu5 = false;
                    this.tableData[d].shifougaishu6 = false;
                    this.tableData[d].shifougaishu7 = false;
                    this.tableData[d].shifougaishu8 = false;
                    this.tableData[d].shifougaishu9 = false;
                    this.tableData[d].shifougaishu10 = false;
                    this.tableData[d].shifougaishu11 = false;
                    this.tableData[d].shifougaishu12 = false;
                    this.tableData[d].shifougaishu13 = false;
                    this.tableData[d].shifougaishu14 = false;
                    this.tableData[d].shifougaishu15 = false;
                    this.tableData[d].flags1 = false;
                    this.tableData[d].flags2 = false;
                    this.tableData[d].flags3 = false;
                    this.tableData[d].flags4 = false;
                    this.tableData[d].flags5 = false;
                    this.tableData[d].flags6 = false;
                    this.tableData[d].flags7 = false;
                    this.tableData[d].flags8 = false;
                    this.tableData[d].flags9 = false;
                    this.tableData[d].flags10 = false;
                    this.tableData[d].flags11 = false;
                    this.tableData[d].flags12 = false;
                    this.tableData[d].flags13 = false;
                    this.tableData[d].flags14 = false;
                    this.tableData[d].flags15 = false;

                    for (var dd in this.beigaishude) {

                        if (this.beigaishude[dd].canshuxulie == this.tableData[d].canshuxulie && this.beigaishude[dd].flag == true) {

                            this.tableData[d][this.beigaishude[dd].xinghaoji] = true;

                        }

                    }

                }


            },


            //获取海外的项目产品翻页
            haiwaiquery(q) {

                //表格初始化
                this.biaogechuzhi();

                if (q) {

                    //项目id
                    this.ajaxRequest.fileName = q;

                } else if (this.proid) {

                    //项目id
                    this.ajaxRequest.fileName = this.proid;

                }

                //获取项目下所有产品id
                ss.FormulaHaiwai.haiwaixiangmuwuliaoPage(this.ajaxRequest).then(rd => {

                    console.log(rd, '看看返回啥')

                    //加载默认项
                    this.jiazaicolumndata(rd.records);

                })


            },


            //加载默认项
            jiazaicolumndata(q) {

                //遍历物料号
                for (var c in q) {

                    //遍历表格
                    for (var d in this.tableData) {

                        //第一行 物料编码
                        if (d == 0) {

                            //对应第几个项目产品的物料编号
                            this.tableData[d]['xinghao' + (parseInt(c) + 1)] = q[c];

                        }

                    }

                    //加载默认项
                    var cc = {

                        'prop': 'xinghao' + (new big(parseInt(c)).plus(1).toString()),
                        'label': '型号' + (new big(parseInt(c)).plus(1).toString()),
                        'dijige': (new big(parseInt(c)).plus(1).toString()),
                        'flagsindex': (new big(parseInt(c)).plus(1).toString()),

                    };


                    this.columndata.push(cc);

                }

            },


            mianfeibeijianfeichangetype(value) {

                console.log(value);

            },

            huilvchangetype(value) {

                console.log(value);


            },


            // //付款方式选择方法
            // fukuanfangshichangetype(value) {
            //
            //     console.log(value);
            //
            //     this.ProMain.zhangqi = value.code.split("OA")[1];
            //
            // },


            //切换计算版本
            qiehuanbanben() {

                if (this.meiyoubanben == true) {

                    this.$msg.msge("没有测算版本")

                } else {

                    this.bianji();

                }


            },

            //编辑
            bianji(){

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];
                this.huidiao();

                //查找工具版记录
                this.chazhaogongjubanjilu();

            },

            //原始审批版本查看
            caiwuzancunyuanshibanben() {

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];
                this.huidiao();


                //加载对应历史记录版本
                this.zaijiajisuanjilu(this.rversion);

                this.dangqiancaiwuzancun = false;

            },

            //切换计算版本
            qiehuanbanbencaiwuzancun() {

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];
                this.huidiao();

                //查找工具版记录
                this.chazhaocaiwuzancun();
            },

            //查找工具版记录
            chazhaogongjubanjilu() {

                //不传项目id就是工具版的非项目记录
                this.chazhaojisuanguocheng(null);

            },


            //取消按钮
            quxiaoanniu() {

                //返回首页
                // this.$router.push({
                //     path: '/rvlistshow'
                // });
                 this.$router.go(-1);
            },


            //逻辑删除版本
            handleDelete() {

                if (this.rversion) {

                    var id = {

                        id: this.rversion

                    }

                    ss.FormulaNew.luojishanchu(id).then(rd => {

                        this.$msg.msgs(rd.msg)

                        this.qiehuanbanben();

                    })

                } else {
                    this.$msg.msge("未选择计算版本")
                }

            },


            //返回上页
            fanhuishangye() {

                //跳转
                //this.$router.push("/rvlistshow");
                this.$router.go(-1);
            },
              //新
            fanhuiliebiao() {

                //跳转
                this.$router.go(-1);
                //this.$router.back();
            },

            //查找财务暂存记录
            chazhaocaiwuzancun() {

                var rversion = {

                    rversion: this.rversion,

                }

                ss.FormulaNew.findcaiwuzancun(rversion).then(rd => {

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.showcaiwuzancun = false;

                        // //初始化表
                        // this.haiwaiquery(q);

                    } else { //查到记录

                        var num = 0;

                        //遍历计算版本map
                        for (var i in rd.obj) {

                            //存计算版本
                            this.caiwuzancunlist.push(rd.obj[i])

                            console.log(i, '反正--------')

                            console.log(rd.obj[i], '---------反正')

                            console.log(i, 'i.rversion')


                            //加载计算版本下拉选
                            var d = {

                                instid: rd.obj[i].instid,
                                value: i,
                                label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                            }

                            console.log(d, 'dddddd??')

                            //计算版本选项
                            this.banbenop.push(d);


                            num++;


                        }

                        //弹出选框
                        this.showcaiwuzancun = true;

                    }


                })


            },

            //查找计算记录
            chazhaojisuanguocheng(q) {

                var pid = {

                    proid: q,
                    neixiaowaixiao: 1,

                }

                ss.FormulaNew.findguochengHaiwai(pid).then(rd => {

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.refuseDialog = false;

                        // //初始化表
                        // this.haiwaiquery(q);

                    } else { //查到记录

                        var num = 0;

                        //遍历计算版本map
                        for (var i in rd.obj) {

                            //存计算版本
                            this.guochenglist.push(rd.obj[i])

                            console.log(i, '反正--------')

                            console.log(rd.obj[i], '---------反正')

                            console.log(i, 'i.rversion')

                            //是当前登陆人创建得
                            if (rd.obj[i].cucode == this._user.usercode) {

                                //加载计算版本下拉选
                                var d = {

                                    instid: rd.obj[i].instid,
                                    value: i,
                                    label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                                }

                                console.log(d, 'dddddd??')

                                //计算版本选项
                                this.banbenop.push(d);


                                num++;
                            }

                        }

                        //弹出选框
                        this.refuseDialog = true;

                    }


                })


            },


            //关闭选择框加载数据
            gettable() {

                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.zaijiajisuanjilu(this.rversion);

                }
                // else{//没版本
                //
                //     //初始化
                //     this.haiwaiquery();
                //
                // }


            },


            //关闭选择框加载数据
            gettablecaiwuzancun() {
                console.log(this.banbenid,"banben???");
                console.log(this.rversion,"babnefjkdsfdsjkafffffffff");
                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.zaijiajisuanjilucaiwuzancun(this.rversion);

                }
                // else{//没版本
                //
                //     //初始化
                //     this.haiwaiquery();
                //
                // }


            },

            //查找财务单保存
            chazhaocaiwudanbaocun(q) {
                ss.FormulaNew.finddanbaocun(q).then(rd => {
                    console.log(rd, 'rdrdrdrdoooooo')
                    if (JSON.stringify(rd.obj) != '{}' && rd.obj.rversion != null && rd.obj.rversion != '') {
                        this.cesuanid = rd.obj.rversion;
                    }
                })

            },


            //加载历史财务计算记录
            zaijiajisuanjilucaiwuzancun(q) {


                var rversion = {

                    rversion: q,

                }

                //加载记录版本
                ss.FormulaNew.getjisuanjilucaiwuzancun(rversion).then(rd => {


                    //当前是财务暂存
                    this.dangqiancaiwuzancun = true;

                    //暂存id
                    this.zancunid = rd.rateFormulaRenewVer.zancunid;

                    //还原版本号
                    this.rversion = rd.rateFormulaRenewVer.rversion;

                    if (rd.rateFormulaRenewVer.status != 0) {

                        this.shifouzhidu = true;

                    }

                    console.log(rd, 'aaa')

                    //判断instid
                    this.panduaninstid(rd.rateFormulaRenewVer);

                    //如果是被驳回的版本
                    if (rd.rateFormulaRenewVer.status == 3) {

                        //不是审批页面
                        this.shenpiyemian = false;

                        //是被驳回的
                        this.beibohui = true;

                        //审批意见
                        this.ProMain.shenpiyijian = rd.rateFormulaRenewVer.shenpijindu.split("_").length == 3 ? rd.rateFormulaRenewVer.shenpijindu
                            .split("_")[2] : "";

                        //显示审批意见
                        this.shenpiyijianshow = true;

                        //查找财务单保存
                        this.chazhaocaiwudanbaocun(rversion);

                    }


                    //加载默认项
                    this.jiazaicolumndata(rd.marcode);

                    //把编号集放集
                    this.duoxinghaocesuan = rd.marcode;

                    //把加载配置按钮去掉
                    this.xianshijilu = true;

                    //显示编号集
                    this.duoxinghao = true;


                    if (rd.yes != null && rd.yes == true) {

                        //新的解析加载  添加相同型号
                        this.listjiazai(rd);

                        console.log("1")

                    } else {

                        //加载表
                        this.jiazaibiao(rd);

                        console.log("2")
                    }


                })

            },


            //加载历史计算记录
            zaijiajisuanjilu(q) {

                // //初始化表
                // this.biaogechuzhi();

                var rversion = {

                    rversion: q,

                }

                //加载记录版本
                ss.FormulaNew.getjisuanjilu(rversion).then(rd => {

                    if (rd.rateFormulaRenewVer.status != 0) {

                        this.shifouzhidu = true;

                    }

                    console.log(rd, 'aaa');

                    //判断instid
                    this.panduaninstid(rd.rateFormulaRenewVer);

                    //如果是被驳回的版本
                    if (rd.rateFormulaRenewVer.status == 3) {

                        //不是审批页面
                        this.shenpiyemian = false;

                        //是被驳回的
                        this.beibohui = true;

                        //审批意见
                        this.ProMain.shenpiyijian = rd.rateFormulaRenewVer.shenpijindu.split("_").length == 3 ? rd.rateFormulaRenewVer.shenpijindu
                            .split("_")[2] : "";

                        //显示审批意见
                        this.shenpiyijianshow = true;

                        //查找财务单保存
                        this.chazhaocaiwudanbaocun(rversion);

                    }


                    //加载默认项
                    this.jiazaicolumndata(rd.marcode);

                    //把编号集放集
                    this.duoxinghaocesuan = rd.marcode;

                    //把加载配置按钮去掉
                    this.xianshijilu = true;

                    //显示编号集
                    this.duoxinghao = true;


                    if (rd.yes != null && rd.yes == true) {

                        //新的解析加载  添加相同型号
                        this.listjiazai(rd);

                        console.log("1")
                    } else {

                        //加载表
                        this.jiazaibiao(rd);

                        console.log("2")
                    }

                })

            },


            //选没选值
            xuanmeixuanzhi(done) {

                this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        if (!this.banbenid) {
                            this.$msg.msge('请先选择')
                            console.log('请先选择')
                        } else {

                            console.log(this.banbenid, '选中没')

                            done();

                        }

                    })
                    .catch(_ => {

                    });

            },


            //选择，将被选中存起来
            fuzhi() {

                console.log(this.banbenid, '看看选择的对不对')

                //计算版本  选中计算版本
                this.rversion = this.banbenid;

            },


            //提交去申请特价
            tijiaoshenqingtejia() {

                console.log(this.proid, '看看项目号')

                //跳转特价页面
                this.$router.push({
                    path: '/pricenew',
                    query: {
                        proid: this.proid
                    }
                });

            },


            con(i) {
                console.log(i)
            },
            getit() {
                return 1
            },
            dblclick(v, h, c, d) {
                console.log(v, h, c, d, '???;;??')
            },
            arraySpanMethod({
                                row,
                                column,
                                rowIndex,
                                columnIndex
                            }) {
                if (rowIndex % 3 === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({
                                 row,
                                 column,
                                 rowIndex,
                                 columnIndex
                             }) {

                //不是销售经理
                if (!this.shifouxiaoshoujingli) {

                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            };
                        } else if (rowIndex === 4) { // 当第7行就为正常的一行；要返回 把1行合并为一列
                            return {
                                rowspan: 11,
                                colspan: 1
                            };
                        } else if (rowIndex === 15) {
                            return {
                                rowspan: 3,
                                colspan: 1
                            }
                        } else if (rowIndex === 18) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 22) {
                            return {
                                rowspan: 17,
                                colspan: 1
                            }
                        } else if (rowIndex === 39) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        } else if (rowIndex === 41) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 45) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        } else if (rowIndex === 47) {
                            return {
                                rowspan: 12,
                                colspan: 1
                            }
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }
                    if (columnIndex === 1) {
                        if (rowIndex === 27) {
                            return {
                                rowspan: 3,
                                colspan: 1
                            };
                        } else if (rowIndex === 28) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 29) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 32) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 33) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 34) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 35) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 36) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 37) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else {
                            return {
                                rowspan: 1,
                                colspan: 1
                            }
                        }
                    }
                    ;


                } else { //销售经理

                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            };
                        } else if (rowIndex === 4) {
                            return {
                                rowspan: 10,
                                colspan: 1
                            };
                        } else if (rowIndex === 23) {
                            return {
                                rowspan: 16,
                                colspan: 1
                            }
                        } else if (rowIndex === 18) {
                            return {
                                rowspan: 1,
                                colspan: 1
                            };
                        }else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }

                }


            },


            // //查询翻页
            // query() {
            //
            //     ss.FormulaNew.selectPage(this.q).then(rd => {
            //
            //         if(rd.f!=null&&rd.f==false){
            //             this.$msg.msge(rd.msg)
            //
            //             //跳转
            //             this.$router.push("/personal/dealCenter");
            //
            //         }
            //
            //         this.q.total = rd.total;
            //
            //         this.xiangmuchanpinlist = rd.records;
            //
            //         console.log(this.xiangmuchanpinlist,'看看查到多少项目产品')
            //
            //
            //         if(this.shoucijiaohu){
            //
            //             //默认首次交互
            //             this.getconfigs(0);
            //
            //         }
            //
            //     })
            //
            // },


            // handleFilter() {
            //     this.q.pageNo = 1;
            //     this.query();
            // },


            haiwaihandleFilter() {
                this.q.pageNo = 1;
                this.haiwaiquery();
            },


            //保修期选择方法
            // repairchangetype(value) {
            //     console.log(value);

            //     if (value) {

            //         this.repairtype = value.code;

            //     }

            // },


            //判断是否达到盈利目标
            shifoudadaoyinglimubiao(q) {
                console.log(q,"判断是否达到盈利目标");
                //总利润   4
                this.lirunzong = parseFloat(q.w48);

                //总经营贡献  2
                this.jingyinggongxiangzong = parseFloat(q.w42);

                //损益表毛利率总额
                this.zongmaolilvbiao = parseFloat(new big(q.sunyibiaocailiaomaolilv).div(this.zonggeshu == 0 ? 1 : this.zonggeshu).toString());

                //毛利率总额
                var mailizong = parseFloat(new big(q.w24).div(this.zonggeshu == 0 ? 1 : this.zonggeshu).toString());

                //显示总毛利率%  1
                this.zongmaolilv = parseInt((mailizong *= 100));

                console.log(this.zongmaolilvbiao, '总毛利表值')
                console.log(mailizong, '总毛利值')


                if (this.tableData[46].hejiE) {

                    if (parseFloat(this.tableData[46].hejiE) >= 0.25) {

                        this.xianshinage = 0;

                    } else {

                        this.xianshinage = 1;
                    }

                }


            },


        }
    }
</script>
<style scoped>
    .h-piece,
    .h-table {
        margin: 20px;
    }

    .xingxing {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
        background-color: rgb(118, 201, 118);
    }

    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }

    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }

    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }

    .tip {
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top: 10px;
    }

    .h-bgccc {
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    }

    .drags {
        background-color: #ffffff;
        margin-bottom: 30px;
    }

    .l-style {
        width: 100%;
        height: auto;
        font-size: 0.2rem;
        color: #4a4a4a;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0.7rem;
    }

    .l-style div {
        flex-shrink: 0;
    }

    .l-styleBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 90%;
        flex-wrap: wrap;
    }

    .l-styleBox .l-stylelist {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 0.1rem;
        margin-bottom: 0.1rem;
        cursor: pointer;
    }

    .l-styleBox .l-stylelist .l-styletext {
        padding: 0.05rem 0.1rem;
        border-radius: 0.3rem;
        background: #2686e7;
        color: #fff;
        font-size: 0.16rem;
        position: relative;
        text-align: center;
        cursor: pointer;
    }


    .l-styleBox .l-stylelist .l-styletext .l-styledel {
        position: absolute;
        top: -6px;
        right: -5px;
        width: 0.16rem;
        height: 0.16rem;
        text-align: center;
        line-height: 0.16rem;
        font-size: 0.12rem;
        color: #fff;
        background: #ccc;
        border-radius: 50%;
        display: none;
        cursor: pointer;
    }

    .l-styleBox .l-stylelist .l-styletext:hover .l-styledel {
        display: block;
    }

    .tan {
        margin: 30px 0 0 0;
    }
</style>
<style>
    .h-enter .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .h-enter .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .h-enter .h-formbLine .el-form-item__content {
        width: 57%;
    }
	.h-enter .h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 12.5%;
	}
	.h-enter .h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 86.5%;
	}
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }

    .selectorBox .el-upload-list {
        display: none;
    }


    .drags .el-slider__button-wrapper .el-slider__button {
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    }

    .fenyes .h-pagiLabel {
        display: none;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }
</style>


<style scoped>
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA,
    .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }
</style>

<style scoped lang="scss">
    $ft-colorg: #21d16f; //绿色的字
    $ft-coloro: #e79118; //黄色的字
    $bg-colorg: #f6fffa; //绿色的背景色
    $bg-coloro: #fffbf7; //黄色的背景色
    $bg-colorb: #3b77fc; //蓝色
    $bg-colorgrey: #c3c3c3; //灰色

    .yx_progressBar {
        width: 100%;
        border: 1px solid $ft-colorg;
        background-color: $bg-colorg;
        padding: 0.38rem;
        position: relative;

        .yxExtra {
            position: absolute;
            color: $ft-colorg;
            top: 0.3rem;
            font-size: 0.18rem;
            right: 0.3rem;
        }

        .yx_topTip {
            display: flex;
            justify-content: flex-start;
            color: #424441;
            font-size: 0.18rem;

            .leftdes {
                margin-right: 0.75rem;
            }

            .percent {
                color: $ft-colorg;
            }
        }

        .con_progress {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.3rem;

            .eve_proout {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                &:last-child .line_pro {
                    display: none;
                }

                .eve_pro {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    position: relative;
                    background-color: $bg-colorgrey;

                    .persons {
                        position: absolute;
                        top: 20px;
                        min-width: 1.8rem;
                        text-align: center;
                        margin-left: -0.75rem;
                        margin-top: 0.04rem;
                        font-size: 0.18rem;
                    }

                    .personsAc {
                        color: $bg-colorb;
                    }
                }


                .line_pro {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorgrey;
                }

                // 激活
                .eve_proAc {
                    background-color: $bg-colorb;
                }

                .line_proAc {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }

                .eve_proAcpass {
                    background-color: $bg-colorgrey;
                }

                .line_proAcpass {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }
            }

        }
    }

    .yx_progressBarAc {
        border: 1px solid $ft-coloro;
        background-color: $bg-coloro;

        .yxExtra {
            color: $ft-coloro;
        }

        .yx_topTip {
            .percent {
                color: $ft-coloro;
            }
        }
    }


    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA,
    .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
        display: flex;
        justify-content: center;
        margin-top: 0.7rem
    }
</style>

<style>
    .el-table .hidden-row {
        display: none;
    }

    .ljjrange .el-range-editor .el-range-separator {
        line-height: 18px;
    }

    .tan .h-formbLine .el-form-item__label {
        width: 47%;
    }

    .tan .h-formbLine .el-form-item__content {
        width: 53%
    }

    .tan .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .tan .h-elformWrap-1 .el-form-item__label {
        width: 20%;
    }

    .tan .h-elformWrap-1 .el-form-item__content {
        width: 80%;
    }
	.ffff .h-formbLine .el-form-item__label {
	    width: 23%
	}

	.ffff .h-formbLine .el-form-item__content {
	    width: 77%
	}
	.ljjtableenterlkw .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtableenterlkw .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
